import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react';
import { IconButton, LinearProgress, ListItem, ListItemText, Tab, Tabs, List } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { IoMdCloseCircle as MdClose } from 'react-icons/io'
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { FiCopy, FiUpload, FiTrash2, FiFilter, FiEdit2 } from 'react-icons/fi';
import { AiOutlineDollar } from "react-icons/ai";
import { TbReportAnalytics } from "react-icons/tb";
import { MdOutlineHandyman } from 'react-icons/md';
import { RiRulerLine } from 'react-icons/ri';
import { RiDeleteBin6Line } from "react-icons/ri";
import { BsListTask } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import HOC from '../HOC/HOC';
import { tagStatusNew } from '../redux/ctrl/vals';
// import "@ag-grid-community/core/dist/styles/ag-grid.css";
// import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import { batch, useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import { AiFillFilter } from "react-icons/ai"
import { LuFilterX } from "react-icons/lu"
import { TfiCommentAlt } from "react-icons/tfi";


import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import Select from 'react-select';
import PkgSelRenderer from './pkgSel';
import DivSel from './divSel';
import TagStatus from './tagStatus';
import { switchPkgTags, switchTTTagAct, updTagAct, fetchTagCountAct, switchDataset, hideProgressBar, createCopyTag, removeChildTag, switchDatasetChild, delTagRes, deleteTags, bulkTagConfigStatusStart, bulkTagConfigStart, changeLoadingPhaseStatus, updatePkgCmntStart, editPkgCmntStart } from '../redux/project/projActions';
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import getDt, { addCommas, getAgGridIndexofSelectedRows, getNumber, statusBar, useOrgId } from '../../utils';
import { getTTLabel, getDtfrmt, dateFmtToStr } from '../../utils';
import toastr from 'toastr';
import './tagGrid.scss';
import "toastr/build/toastr.min.css";
import { assignTags, changeWSTab, hidePkgAct, hideTags, showLoader } from '../redux/ctrl/ctrlActions';
import { currencies, tagStatusNew2, tagStatusActions } from '../redux/ctrl/vals';
import WildSearchFilter from './WildSearchFilter';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import SelectInput from '../shared/Selectinput';
import useLongPress from './useLongPress';
import StyledTooltip from '../shared/toolTip/StyledTooltip';
import { convertWildcardStringToRegExp } from './WildcardSearch'
import { updateReviStartAct, createUpdtReviPhaseAct, createDuplicateLine } from "../redux/revision/revAction";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import ReportHub from "./reportHub";
import SelectReportType from "./SelectReportType";
import BatchReportStatusModal from "./BatchReportStatusModal";
import DeleteTag from './deleteTag';
//import ConfigDet from './configDetail';
import OptionMenu from '../shared/optionMenu/menu';
import BulkConfig from './bulkConfig';
import { IoCheckmarkDoneSharp, IoDuplicate } from 'react-icons/io5';
import { agGridTrans } from "../translation/i18n";
import { paGetSizingAPI, pricingAPI } from '../apis/pgapis';
import { postpricingdatastart } from '../redux/project/projActions';
import { fetchUserPreferenceAct } from "../redux/profile/profileActions";
import { set } from 'react-ga';
import axios from 'axios';
import { FaLink } from 'react-icons/fa6';
import LinkTag from './linkTag';
import RelatedTagModal from './RelatedTagModal';
import CustomTooltip from '../userProjects/customTooltip';
import COLORS from '../styles/COLORS';


function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
    //  cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}


let dispatchRow = [];
let dispatchSize = 20;
let undoLimit = 1;

const MultiTagComboStyle = {
  control: (base, state) => ({
    ...base,
    background: "#fff",
    // match with the menu
    borderRadius: 0,
    // Overwrittes the different states of border
    borderColor: state.isFocused ? "#80bdff" : "#ced4da",
    // Removes weird border around container
    boxShadow: null,
    '&:hover': {
      borderColor: '#c6c6c6;'
    },
    height: '25px',
    minHeight: '25px',
    width: '150px',
  }),
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: 0,
    // beautify the word cut by adding a dash see https://caniuse.com/#search=hyphens for the compatibility
    hyphens: "auto",
    // kill the gap
    marginTop: 0,
    textAlign: "left",
    // prevent menu to scroll y
    wordWrap: "break-word",
  }),
  menuList: base => ({
    ...base,
    // kill the white space on first and last option
    padding: 0

  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px 12px',
    paddingBottom: '6px'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: '4px',
    color: "hsl(0,0%,60%)"
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: 'none'
  }),
  clearIndicator: (styles) => ({
    ...styles,
    marginBottom: 0,
    marginTop: '-2px'
  }),
  singleValue: (style) => ({
    ...style,
    paddingBottom: '0.2pc'
  }),
  multiValue: (styles) => ({
    ...styles,
    marginBottom: '8px'
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    padding: '2px'
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    paddingLeft: '2px',
    paddingRight: '2px'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  })
};


const disRev = () => {
  return false
}

const PrjTagTable = (props) => {
  const { t, i18n } = useTranslation();
  const { slctRev, onChangeRev, gridApi, setGridApi } = props
  // let history = useHistory();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const childGridRef = useRef(null);
  const grid_ImportFileRef = useRef(null);
  // const [tagsLoaded, setTagsLoaded] = useState(false);
  let getDivs = useSelector((state) => state.ctrl.division_code);
  const profileState = useSelector((state) => state.profile);
  const hiddenFileInput = useRef(null);
  const pckgCouterBadges = useRef(null);
  const prof = useSelector(state => state.profile);
  const ctrl = useSelector(state => state.ctrl);
  const tagdata = useSelector(state => state.prjasn.projectsAsn);
  const [filterTagData, setFilterTagData] = useState([])
  const [ffActive, setffActive] = useState(false)
  // let data = useSelector((state) => state.project.tags.filter(o => o.selected === 'Y'));
  //let childPopUpArray = useSelector((state) => state.project.tagsChild.filter(o => o.selected === 'Y' ));
  let childPopUpArray = useSelector((state) => state.project.tagsChild.filter(o => o.selected === 'Y' && !o.config_status.includes("INPROCESS")));
  // console.log("childPopUpArray:", childPopUpArray);
  const tags = useSelector((state) => state.project.tags);
  //console.log("tags:", tags);
  const selectedTechnologyType = useSelector((state) => state.project.selectedTechnologyType);
  let techTyps = useSelector((state) => state.ctrl.techTypes);
  const selectedPkg = useSelector((state) => state.revision.pkgDetail);
  const [slctdPkgTags, setSlctdPkgTags] = useState([]);
  let eprojs = useSelector((state) => state.project);
  let bulkUpdatedTags = useSelector(state => state.project.bulkUpdatedTags) || [];
  const itemPriceStatus = useSelector((state) => state.project.itemPriceStatus);
  const buOffice = useSelector((state) => state.ctrl.buLkp);
  const operatingUnit = useSelector((state) => state.ctrl.data.operating_unit);
  const userPreference = useSelector((state) => state.profile.userPreference);



  let pkgs = eprojs.packages
  // const [gridApi, setGridApi] = useState(null);
  const [childGridApi, setChildGridApi] = useState(null);
  const [importGridApi, setImportGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [tagState, setTagState] = useState({ showPkg: false, message: '', refresh: false })
  //check the association of child with parent
  const [removeChildAssociation, setRemoveChildAssociation] = useState({ showConfirmation: false, message: '' })
  const [dwOpen, setOpen] = useState(false);
  const [newAddedRowImprtGrd, setNewAddedRowImprtGrd] = useState([]);
  const [importedFileData, setImportedFileData] = useState([]);
  const [allTags, setallTags] = useState(0)
  const [selectedImportGrdRow, setSelectedImportGrdRow] = useState();
  const [selectedCopyTag, setSelectedCopyTag] = useState([]);
  const [parentTableData, setParentTableData] = useState([]);
  const resMesg = useSelector((state) => state.project.resMesg);

  const gtechTyps = useSelector((state) => state.project.techTyps);
  const currSymb = currencies.filter((item) => item.value == ctrl.pkg.currency).map(o => o.symb)[0]
  const SINP = useCallback(HOC(SelectInput, false), []);
  const [badgesHScroll, setBadgesHScroll] = useState(0);
  const [isBadgesScrollEnbl, setIsBadgesScrollEnbl] = useState(false);
  const revisionState = useSelector((state) => state.revision);

  const isTimeOut = useSelector((state) => state.revision.isTimeOut);
  const [saveStatebol, setSaveStateBOl] = useState(true);
  const phase = useSelector((state) => state.project.phase)
  const loadingPhase = useSelector((state) => state.project.loadingPhase)

  const [writeAcc, setWriteAcc] = useState(false);

  const [actRev, setActRev] = useState();
  const [selectedPkgCmnts, setSelectedPkgCmnts] = useState('');
  const [reviSelectOptn, setReviSelectOptn] = useState([]);
  const [fetchtagPBarCount, setFetchtagPBarCount] = useState(0);
  const [copyPopup, setCopyPopup] = useState(false);
  const [selectedCopyOption, setSelectedCopyOption] = useState("");
  // const [copyConfigurationPopup, setCopyConfigurationPopup] = useState(false);
  // const [selectedRowsDataCopyConf, setSelectedRowsDataCopyConf] = useState();
  const [selectedRowsDataCopy, setSelectedRowsDataCopy] = useState();
  const [selectedRowsData, setSelectedRowsData] = useState();
  const [selectedConfigRowsData, setSelectedConfigRowsData] = useState();
  // const [copyConfDisableBtn, setCopyConfDisableBtn] = useState(true);
  const [showCopyErrorPopup, setShowCopyErrorPopup] = useState(false);
  const [duplicateLinePopup, setDuplicateLinePopup] = useState(false);
  const [duplicateLineSelectedChk, setDuplicateLineSelectedChk] = useState([]);
  const [duplicateTagName, setDuplicateTagName] = useState("");
  const [copySizingPopup, setCopySizingPopup] = useState(false);
  const [errors, setErrors] = useState(0);
  const [gettagcntTl, setgettagcntTl] = useState(null);
  const [pendingType, setPendingType] = useState([]);
  const [currentType, setCurrentType] = useState(0);

  const [statusUpdate, setStatusUpdate] = useState(true);
  const [statusUpdateStart, setStatusUpdateStart] = useState(false);
  const [defaultChildSelected, setDefaultChildSelected] = useState([]);
  const [changedChildSelectedData, setChangedChildSelectedData] = useState([]);
  const [removeIcon, setRemoveIcon] = useState('all');
  const [commonParentTagData, setCommonParentTagData] = useState(null);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [confirmationPopup1, setConfirmationPopup1] = useState(false);
  const [confirmationPopup2, setConfirmationPopup2] = useState(false);
  const [confirmationPopup3, setConfirmationPopup3] = useState(false);
  const [commonDS, setCommonDS] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);
  const [restoreActive, setRestoreActive] = useState(false);
  const lastRevCmtItemRef = useRef(null);
  const commentDialogContentRef = useRef(null);
  const commentScrollTopRef = useRef(0);

  // const [actRev, setActRev] = useState();
  // const [prevRev, setPrevRev] = useState();
  // const [reviSelectOptn, setReviSelectOptn] = useState();
  // const [fetchtagPBarCount, setFetchtagPBarCount] = useState(0);

  const { showProgressBar, fetchedDataCnt, gettagcnt, pkgRevsCmnts } = useSelector((state) => state.project);
  const commonLkp = ctrl.commonLkp
  const dpFlowLkp = ctrl.dpFlowLkp
  const flowLkp = ctrl.flowLkp
  const lookupTables = ctrl.datasetsLkp

  const [selDataset, setSelDataset] = useState('Common')
  const [colDefinations, setColDefinations] = useState([])
  const [colDefinationsChild, setColDefinationsChild] = useState([])

  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);
  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === 'Instrumentation' ? true : false;
  const nonConfigProducts = useSelector((state) => state.ctrl.nonConfigProducts);
  const isTabsActive = showProgressBar
  const [isRelTagModalOpen, setIsRelTagModalOpen] = useState(false);
  const [relTagData, setRelTagData] = useState([]);

  let techName = ['Common', ...new Set(gtechTyps.filter(i => !commercialTypes.includes(i.technology_name)).map(i => i.technology_name))]
  let getType = [];

  const [dispatchTagUpdate, SetdispatchTagUpdate] = useState();
  const [confPaste, SetconfPaste] = useState(false);
  const [freezeConfModal, SetfreezeConfModal] = useState(false);
  const [cancelActive, SetCancelActive] = useState(false);
  const [dispatchTagSize, SetdispatchTagSize] = useState(0);
  const [showConfirmData, SetShowConfirmData] = useState(false);
  const [dphTagCount, SetDphTagCount] = useState(0);
  const [changeConfige, SetChangeConfige] = useState(true);
  const [findTagVal, setFindTagVal] = useState(null);
  const [changedField, setChangedField] = useState(null);
  const [findTagFilter, setFindTagFilter] = useState(false);
  const [confPasteEnabled, setConfPasteEnabled] = useState(true);
  const [clicked, setClicked] = useState(false);
  const [delClicked, setDelClicked] = useState(false);
  const [deleteTag, setDeleteTag] = useState([]);
  const [clickFM, setClickFM] = useState(null);
  const [techNames, setTechNames] = useState([]);
  const [destroy, setDestroy] = useState(false);

  const [openReportStatus, setOpenReportStatus] = useState(false);
  const [openSelectReportType, setOpenSelectReportType] = useState(false);
  const [openBatchReportStatus, setOpenBatchReportStatus] = useState(false);
  const [anchorFilter, setFilter] = useState(null);
  const [anchorReport, setReport] = useState(null);
  const [anchorDelete, setDelete] = useState(null);
  const valueToNull = ['pur_configurator_id', 'gen_oracle_quote', 'pur_config_rev_num', 'cloud_config_id', 'quote_hdr_id', 'quote_line_id'];
  const excludeToConfigue = ['tag_line_status', 'tag_number', 'pur_pa_id'];
  const changeConfigeStatus = ['gen_base_model_1', 'gen_base_model_2', 'gen_base_model_3',
    'gen_base_model_4', 'gen_base_model_5', 'gen_base_model_6', 'ord_it_assembly_model',
    'pur_mod_num_part1', 'pur_mod_num_part2', 'pur_mod_num_part3', 'pur_mod_num_part4', 'pur_mod_num_part5', 'pur_mod_num_part6',]

  const [openBulkConfigStatus, setOpenBulkConfigStatus] = useState(false);
  const [tagDataList, settagDataList] = useState([]);
  const [isCellEditable, setIsCellEditable] = useState(true);
  const [anchorPricing, setPricing] = useState(null);



  //let isCellEditable = useSelector((state) => state.project.tagsCheckboxDisabled)

  const [tsActnVal, settsActnVal] = useState(null);
  const [tsValL1, settsValL1] = useState(null);
  const [tsValL1label, settsValL1label] = useState(null);
  const [tsValL2, settsValL2] = useState(null);
  const [dataLoaded, setdataLoaded] = useState(true);
  const [multiRowPL, setmultiRowPL] = useState([]);
  const [pkgDtls2, setpkgDtls2] = useState(null);
  const [multiTagDrop, setmultiTagDrop] = useState(null);
  const [dwStatusOpen, setdwStatusOpen] = useState(false)
  const [loaderBar, setloaderBar] = useState(false)
  const [isLinkTagOpen, setIsLinkTagOpen] = useState(false);
  const { getOrgIdFromDivisionCode } = useOrgId();

  const [openCmtConfirm, setOpenCmtConfirm] = useState(false);
  const [revComments, setRevComments] = useState("");
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [inlineEditMap, setInlineEditMap] = useState({});
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [commentDeleteConfirmOpen, setCommentDeleteConfirmOpen] = useState(false);
  const commentInputRef = useRef(null);


  useEffect(() => {
    if (profileState.email) {
      dispatch(fetchUserPreferenceAct({ email: profileState.email, type: 'tagworkspace' }));
    }
  }, []);

  useEffect(() => {
    if (loadingPhase?.action === "BULK_TAG_CONFIG" && loadingPhase?.phase === "START") {
      setloaderBar(true)
      dispatch(showLoader(true));
    }
    if (loadingPhase?.action === "BULK_TAG_CONFIG" && loadingPhase?.phase === "SUCCESS") {
      if (loadingPhase?.message.ResponseStatus == "Error") {
        toastr.error(loadingPhase?.message.ErrorMessage);
      } else {
        toastr.success("Bulk Configure requested Successfully!");
      }
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
      setloaderBar(false)
      dispatch(showLoader(false));
    }
    if (loadingPhase?.action === "BULK_TAG_CONFIG" && loadingPhase?.phase === "ERROR") {
      toastr.error("Bulk Configure requested Failed!");
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
      setloaderBar(false)
      dispatch(showLoader(false));
    }

    if (loadingPhase?.action === "FETCH_TAGS" && loadingPhase?.phase === "CANCEL") {
      setTimeout(() => {
        gridApi?.hideOverlay()
      }, 0);
    }

    if (loadingPhase?.action === "UPDATE_PKG_CMT" && loadingPhase?.phase === "SUCCESS") {
      toastr.success("Package comments updated successfully");
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
    }

    if (loadingPhase?.action === "UPDATE_PKG_CMT" && loadingPhase?.phase === "ERROR") {
      toastr.error("Package comments update failed");
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
    }

    if (loadingPhase?.action === "EDIT_PKG_CMT" && loadingPhase?.phase === "SUCCESS") {
      toastr.success("Package comment updated successfully");
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
    }

    if (loadingPhase?.action === "EDIT_PKG_CMT" && loadingPhase?.phase === "ERROR") {
      toastr.error("Package comment update failed");
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
    }

  }, [loadingPhase])

  useEffect(() => {
    if (gtechTyps.length === 0 && prof?.bu === 'Isolation Valves') {
      setCommonDS(false);
    } else {
      setCommonDS(true);
    }
    if (techName && prof?.bu === 'Isolation Valves') {
      techName.shift();
      setTechNames(techName);
    } else {
      setTechNames(techName);
    }
  }, [prof.bu, gtechTyps])

  useEffect(() => {
    const tempcheckedTT = []
    gtechTyps.forEach(i => { if (i.selected == "Y") { tempcheckedTT.push(i.technology_name) } })
    //let selectedLookupTable
    const checkedTT = [...new Set(tempcheckedTT)]
    if (checkedTT.length > 1 || checkedTT.length == 0) {
      //selectedLookupTable = lookupTables["Common"]
      !restoreActive && setSelDataset(wsTabValue === "Instrumentation" ? "Common" : wsTabValue)
    } else {
      setSelDataset(checkedTT[0])
      //selectedLookupTable = lookupTables[checkedTT[0]]
    }

    // createDefs(selectedLookupTable);

  }, [gtechTyps]);

  useEffect(() => {
    let selectedLookupTable = lookupTables[selDataset]
    createDefs(selectedLookupTable);
    // setData(selDataset)
    // console.log("selDataset", selDataset)
  }, [selDataset, gtechTyps, userPreference])
  useEffect(() => {
    if (selectedTechnologyType) {
      let selectedLookupTable = lookupTables[selectedTechnologyType]
      createDefsChild(selectedLookupTable);
    }
  }, [selectedTechnologyType, selectedRowsData])
  useEffect(() => {
    if (gettagcnt) {
      let tempTL = 0;
      for (let value of Object.values(gettagcnt)) {
        tempTL += value;
      }
      setgettagcntTl(tempTL);

    }
  }, [gettagcnt])

  useEffect(() => {
    console.log("slctRev?.value changed:", slctRev?.value)
    if (!slctRev?.value)
      return;
    const pkgRevsCmntsArr = pkgRevsCmnts?.find(item => item.project_id === ctrl?.pkg?.project_id && item.package_id === ctrl?.pkg?.package_id && item.revision_number === +slctRev?.value)

    setSelectedPkgCmnts(pkgRevsCmntsArr?.pkgRevHistory)
  }, [pkgRevsCmnts, slctRev?.value])

  useEffect(() => {
    if (openCmtConfirm) {
      setTimeout(() => commentInputRef.current?.focus(), 0);
    }
  }, [openCmtConfirm])

  // const onSelectionChanged = (event) => {
  //   setSelectedRowsData(event.api.getSelectedRows());
  // }

  const onSelectionChanged = (event) => {
    let getSortedRow = getAgGridIndexofSelectedRows(event.api.getSelectedNodes());
    setSelectedRowsData(getSortedRow);
  }
  // const onRowSelected = React.useCallback((event) => {
  //   if (event.node.selected) {
  //     if (event.node.data.config_status.includes("VALID") || event.node.data.config_status.includes("INVALID")) {
  //       //toastr.error(`${event.node.data.tag_number}: Tag Status is ${event.node.data.config_status.split("-")[0]}, It will be ignored for configuration`);
  //     }

  //     if ((event.node.data.gen_base_model_1 === null || event.node.data.gen_base_model_1 === "") &&
  //       (event.node.data.ord_it_assembly_model === null || event.node.data.ord_it_assembly_model === "")) {
  //       //toastr.error(`${event.node.data.tag_number}: Invalid Tag for Configuration, Base Model 1 / Assembly Model Is Missing`);
  //     }
  //     if (event.node.data.pur_mod_num_part1 === null || event.node.data.pur_mod_num_part1 === undefined || event.node.data.pur_mod_num_part1 === "") {
  //       //toastr.error(`${event.node.data.tag_number}: Invalid Tag for Configuration, Model Number 1 Is Missing`);
  //     }
  //   }
  // },
  //   [],
  // );

  const handleDatasetChange = (e) => {
    setSaveStateBOl(false)
    // setData(e);
    saveState();
    setSelDataset(e)
    if (e != 'Common') {
      const pl = {
        package_id: ctrl.pkg.package_id,
        category: e,
      }
      dispatch(switchDataset(pl))
      //settagDataList(null);
      //rowDataUpdated();
    } else {
      const pl = {
        package_id: ctrl.pkg.package_id,
        selected: true
      }
      dispatch(switchPkgTags(pl))
    }
  }
  const onColumnStateChanged = () => {
    console.log("saveStatebol before:", saveStatebol);
    if (!saveStatebol) {
      setSaveStateBOl(true)
    }
    if (saveStatebol && !ctrl.loading) {
      //  console.log("triggered..."); 
      saveState();
      //  save fn will come here
      // setTimeout(() => {
      //   setData(selDataset);
      // }, 10);
    }
    console.log("saveStatebol after:", saveStatebol);

  }

  // const setData = (e) => {
  //   if (JSON.parse(localStorage.getItem(e))?.length > 0) {
  //     // ...
  //     const colState = JSON.parse(localStorage.getItem(e));

  //     let visibleColumns;
  //     if (colState?.length > 0) {
  //       visibleColumns = colState.map(column => {
  //         if (column.colId === "sel") {
  //           return { ...column, hide: false }; // Set hide to false for colId "sel"
  //         } else if (!column.hide) {
  //           if (isColHidden(column.colId)) {
  //             return { ...column, hide: true };
  //           }
  //         }
  //         return column;
  //       });

  //       // console.log("visibleColumns", visibleColumns);
  //       // console.log("colState", colState);
  //     }

  //     setTimeout(() => {
  //       gridRef.current.columnApi?.applyColumnState({
  //         state: visibleColumns,
  //         applyOrder: true,
  //       });
  //     }, 10);
  //     return;
  //   }
  //   // ...
  // }
  // const setData = (e) => {
  //   const colState = JSON.parse(localStorage.getItem(e));
  //   if (!colState || colState.length === 0) {
  //     console.warn("No column state found in localStorage for key:", e);
  //     return;
  //   }

  //   let visibleColumns = colState.map(column => {
  //     if (column.colId === "sel") {
  //       return { ...column, hide: false };
  //     } else if (!column.hide) {
  //       if (isColHidden(column.colId)) {
  //         return { ...column, hide: true };
  //       }
  //     }
  //     return column;
  //   });

  //   setTimeout(() => {
  //     gridRef.current?.columnApi?.applyColumnState({
  //       state: visibleColumns,
  //       applyOrder: true,
  //     });
  //   }, 10);
  // };

  const validateNumericFields = (params, lookup_code) => {
    const fieldValue = params.newValue?.replace(/,/g, '');
    if (fieldValue == '0' || fieldValue == '' || fieldValue == null) {
      params.data[lookup_code] = null
    }
    else if (!Number(fieldValue)) {
      toastr.error(t('Only numeric values are allowed!'))
    }
    else {
      params.data[lookup_code] = fieldValue
    }
  }

  const validateIntegerFields = (params, lookup_code) => {
    const fieldValue = params.newValue?.replace(/,/g, '');
    if (fieldValue == '0' || fieldValue == '' || fieldValue == null) {
      params.data[lookup_code] = null
    }
    else if (!Number.isInteger(Number(fieldValue)) || Number(fieldValue) < 0) {
      toastr.error(t('Only positive integer values are allowed!'))
    }
    else if (params.colDef.field === "quantity" && isInstrumentationTab && fieldValue !== '1') {
      toastr.error(t('Quantity must be 1'));
    }
    else {
      params.data[lookup_code] = Number.parseFloat(fieldValue)
    }
  }

  // const validatePaRefIdField = async (params) =>{
  //   const fieldValue = params.newValue?.replace(/,/g, '');
  //   if (fieldValue == '0' || fieldValue == '' || fieldValue == null) {
  //     params.data.pur_pa_id = null
  //     return true
  //   }
  //   else {
  //     const sizingRes = await paGetSizingAPI(fieldValue)
  //     console.log(sizingRes, "sixing res")
  //     if(sizingRes?.valid){
  //       console.log(fieldValue, 'field val')
  //       // params.data.pur_pa_id = fieldValue
  //       // params.api.refreshCells({ rowNodes: [params.node]})

  //       // params.api.dispatchEvent({
  //       //   type: 'cellValueChanged',
  //       //   rowNode: params.node,
  //       //   column: params.column,
  //       //   newValue: fieldValue,
  //       //   oldValue: params.oldValue
  //       // })
  //       // const transaction = {
  //       //   update: [{...params.data, 'pur_pa_id': fieldValue}]
  //       // }
  //       // params.api.getRowNode(params.node.id).setDataValue('pur_pa_id', fieldValue)

  //       // params.api.applyTransaction(transaction)
  //       return true
  //     }
  //     else {
  //       toastr.error('PA reference id is invalid');
  //       return false
  //     }
  //   }

  // }



  useEffect(() => {

    const isTagUpdateCapb = prof.capb.findIndex((o) => o.PWSUPTAG === 'Y') < 0 ? false : true
    const isLatestRev = slctRev?.value == ctrl.pkg.active_revision || !slctRev ? true : false
    const writeAcc = getWriteAcc()
    setIsCellEditable(isTagUpdateCapb && isLatestRev && writeAcc)

  }, [prof.capb, writeAcc, slctRev, ctrl.pkg.active_revision])


  const renderRelatedTag = (params) => {
    // return params.data.gen_rel_tag
    if (!params.data.gen_rel_tag) return null

    const tagIds = params.data.gen_rel_tag.split(',')
    const tagNumbers = tagIds.map((tagId) => {
      const tag = tags.find((tag) => tag.tag_id == tagId)
      return tag.tag_number
    })
    return tagNumbers.join(',')
  }

  const onCellClicked = (params) => {
    if (params.colDef.field === 'gen_rel_tag' && params.value) {
      setRelTagData(params.value.split(','))
      setIsRelTagModalOpen(true)
    }
  }



  const getDropdownValues = (operatingUnit, buOffice) => {
    const matchedOffice = buOffice.find((office) => office.meaning === operatingUnit);
    if (matchedOffice && matchedOffice.attribute1) {
      // Convert attribute1 into an object
      const attributeObject = matchedOffice.attribute1.split(",").reduce((acc, item) => {
        const [key, value] = item.split(":");
        if (key && value) {
          acc[key.trim()] = value.trim();
        }
        return acc;
      }, {});

      // Return only the keys as dropdown values
      return Object.keys(attributeObject);
    }
    return [];
  };

  const division1 = getDropdownValues(operatingUnit, buOffice);




  function createDefs(dataset, bool) {
    const commonField = [
      { headerName: 'Package ID', field: 'package_id', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: 'Project ID', field: 'project_id', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: 'Tag ID', field: 'tag_id', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: 'Rev', field: 'revision', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: "", field: 'sel', width: 55, filter: false, menuTabs: false, resizable: false, checkboxSelection: true, showDisabledCheckboxes: true, suppressMenu: true, suppressColumnsToolPanel: true, editable: false, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, pinned: 'left', lockPosition: true },
      // { headerName: "#", field: 'sno', width: 55, filter: false, menuTabs: false, resizable: true, valueGetter: getRow, suppressMenu: true, suppressColumnsToolPanel: true, editable: false },
      { headerName: 'Sr.No.', field: 'srno', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true, valueGetter: getRow },
      // { headerName: '', field: 'search', width: '30', maxWidth: '30', filter: false, hide: false, resizable: false, sortable: false, suppressMenu: true, suppressColumnsToolPanel: true, valueGetter: getRow },

    ]

    const editFalseField = ['pur_total_unit_price', 'pur_total_sell_price', 'gen_technology_type', 'gen_prod_desc', 'gen_instrument_type', 'config_status', 'purchase_total_price', 'pur_configurator_id', 'gen_oracle_quote', 'pur_config_rev_num', 'quote_hdr_id', 'quote_line_id', 'gen_rel_tag', 'gen_costing_status']
    const priceFields = ['pur_unit_list_price1', 'pur_unit_list_price2', 'pur_unit_list_price3', 'pur_unit_list_price4', 'pur_unit_list_price5', 'pur_unit_list_price6', 'pur_total_unit_price', 'purchase_total_price', 'pur_sell_list_price1', 'pur_sell_list_price2',
      'pur_sell_list_price3', 'pur_sell_list_price4', 'pur_sell_list_price5', 'pur_sell_list_price6', 'pur_total_sell_price']
    const numericFields = ['purchase_discount']
    const integerFields = ['quantity', 'request_id']

    // Get user preferences for the selected dataset
    let preferenceColumns = null;
    if (userPreference && userPreference.preference_key === 'tagworkspace' && userPreference?.columns) {
      // debugger
      // First try to find in direct columns
      preferenceColumns = userPreference.columns[selDataset];

      // If not found, try in Instrumentation
      if (!preferenceColumns && userPreference.columns.Instrumentation) {
        preferenceColumns = userPreference.columns.Instrumentation[selDataset];
      }
    }



    const result = [];
    const tagObj = {};
    console.log(preferenceColumns, "preference")
    if (preferenceColumns?.length > 0) {
      // Create a map of lookup_code to column_order from preferences
      const preferenceOrderMap = {};
      let maxPreferenceOrder = 0;
      preferenceColumns.forEach(prefCol => {
        if (prefCol.column_name != null && prefCol.column_order != null) {
          const order = typeof prefCol.column_order === 'string' ? parseInt(prefCol.column_order, 10) : prefCol.column_order;
          preferenceOrderMap[prefCol.column_name] = order;
          if (order >= maxPreferenceOrder) {
            maxPreferenceOrder = order;
          }
        }
      });
      console.log('preferenceOrderMap', preferenceOrderMap, 'maxPreferenceOrder', maxPreferenceOrder);

      // Build a sorted flat list of all items using preference order
      let nextSequence = maxPreferenceOrder + 1;
      const allItems = dataset.map((item) => {
        const newSequence = (item.lookup_code in preferenceOrderMap)
          ? preferenceOrderMap[item.lookup_code]
          : nextSequence++;
        return { ...item, _sortOrder: newSequence };
      });
      allItems.sort((a, b) => a._sortOrder - b._sortOrder);

      // Build interleaved column groups - same tag can appear multiple times
      // Walk through sorted items: consecutive items with the same tag share a group,
      // when the tag changes, start a new group (even if that tag appeared before)
      let currentTag = null;
      let currentChildren = [];
      let isFirstCommonGroup = true;

      const flushGroup = () => {
        if (currentTag && currentChildren.length > 0) {
          if (currentTag === 'Common' && isFirstCommonGroup) {
            currentChildren.unshift(...commonField);
            isFirstCommonGroup = false;
          }
          result.push({
            headerName: t(currentTag),
            children: [...currentChildren]
          });
        }
      };

      allItems.forEach((item) => {
        const { tag, lookup_code, meaning } = item;

        if (tag !== currentTag) {
          // Tag changed - flush current group and start new one
          flushGroup();
          currentTag = tag;
          currentChildren = [];
        }

        const isHide = isColHidden(lookup_code);
        const colDef = {
          headerName: meaning,
          field: lookup_code,
          hide: isHide,
          // suppressMenu: isHide,
          suppressColumnsToolPanel: false,
          ...((lookup_code == 'tag_number') && {
            comparator: AlphaNumericComp,
          }),
          ...((lookup_code == 'comm_description' || lookup_code == 'comm_library_element') && { filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true }),
          ...(editFalseField.includes(lookup_code) && { editable: false }),
          ...(lookup_code == 'pur_remark' && { cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellEditorParams: { maxLength: 240, rows: 10, cols: 60 } }),
          ...(lookup_code == 'purchase_error_details' && { cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellEditorParams: { maxLength: 3000, maxLengthrows: 10, cols: 60 } }),
          ...(lookup_code == 'division_code' && {
            suppressPaste: true,
            suppressKeyboardEvent: (params) => {
              const KEY_DELETE = 46;
              return params.event.keyCode === KEY_DELETE;
            },
            cellEditorSelector: (params) => {
              if (params.data.config_status.includes("INPROCESS") || params.data.gen_costing_status == "IN PROCESS") {
                return null;
              }
              return {
                component: 'agRichSelectCellEditor',
                popup: true,
                params: {
                  cellHeight: 30,
                  values: division1,
                }
              };
            },
            filter: true,
          }),
          ...(lookup_code == 'tag_line_status' && {
            suppressPaste: true,
            suppressFillHandle: true,
            suppressKeyboardEvent: (params) => {
              return params.event.keyCode === 46 || params.event.keyCode === 8;
            },
            valueSetter: (params) => {
              if (params.newValue === null || params.newValue === undefined || params.newValue === '') {
                return false;
              }
              params.data.tag_line_status = params.newValue;
              return true;
            },
            cellEditorSelector: (params) => {
              if (params.data.config_status.includes("INPROCESS") || params.data.gen_costing_status == "IN PROCESS") {
                return null;
              }
              return {
                component: 'agRichSelectCellEditor',
                popup: true,
                params: {
                  cellHeight: 30,
                  values: tagStatusNew2,
                }
              };
            },
            filter: true,
          }),
          ...(numericFields.includes(lookup_code) && { valueSetter: (params) => validateNumericFields(params, lookup_code) }),
          ...(integerFields.includes(lookup_code) && { valueSetter: (params) => validateIntegerFields(params, lookup_code) }),
          ...(priceFields.includes(lookup_code) && {
            valueSetter: (params) => validateNumericFields(params, lookup_code),
            valueGetter: (params) => addCommas(params, lookup_code)
          }),
          ...(lookup_code === 'purchase_total_price' && { valueGetter: (params) => addCommas(params, lookup_code) }),
          ...(lookup_code === 'gen_rel_tag' && {
            cellStyle: { cursor: 'pointer' },
            valueGetter: renderRelatedTag,
          }),
        };

        currentChildren.push(colDef);
      });

      // Flush the last group
      flushGroup();

      console.log(result, '---interleaved result from preferences---');
      if (bool == false) { return result }
      setColDefinations(result);
      return;

    } else {
      dataset.sort((a, b) => a.group_sequence - b.group_sequence);
      dataset.forEach((item) => {
        const { tag, group_sequence, sequence, ...rest } = item;
        if (!tagObj[tag]) {
          tagObj[tag] = [];
        }
        tagObj[tag].push({ group_sequence, sequence, ...rest });
      });
    }

    console.log('tagObjtagObj', tagObj)

    for (const tag in tagObj) {
      const children = tagObj[tag].sort((a, b) => a.sequence - b.sequence);
      if (tag == "Common") {
        const tempChild = children.map(({ meaning, lookup_code }) =>
        ({
          headerName: meaning,
          field: lookup_code,
          ...((lookup_code == 'tag_number') && {
            comparator: AlphaNumericComp,
            hide: isColHidden(lookup_code)
          }),
          ...((lookup_code == 'comm_description' || lookup_code == 'comm_library_element') && { filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true })
        }))
        tempChild.unshift(...commonField)
        result.push({
          headerName: t(tag),
          children: tempChild
        });
      }

      else {
        result.push({
          headerName: t(tag),
          children: children.map(({ meaning, lookup_code }) => {
            let isHide = isColHidden(lookup_code)
            return (
              {
                headerName: meaning,
                field: lookup_code,
                hide: isHide,
                suppressMenu: isHide,
                suppressColumnsToolPanel: false,
                ...(lookup_code == 'pur_remark' && { cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellEditorParams: { maxLength: 240, rows: 10, cols: 60 } }),
                ...(lookup_code == 'purchase_error_details' && { cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellEditorParams: { maxLength: 3000, maxLengthrows: 10, cols: 60 } }),
                ...(editFalseField.includes(lookup_code) && { editable: false }),
                ...(lookup_code == 'division_code' && {
                  suppressPaste: true,
                  suppressKeyboardEvent: (params) => {
                    const KEY_DELETE = 46;
                    return params.event.keyCode === KEY_DELETE;
                  },
                  cellEditorSelector: (params) => {
                    if (params.data.config_status.includes("INPROCESS") || params.data.gen_costing_status == "IN PROCESS") {
                      return null; // Disable cell editor if cell is greyed out
                    }
                    return {
                      component: 'agRichSelectCellEditor',
                      popup: true,
                      params: {
                        cellHeight: 30,
                        values: division1,
                      }
                    };
                  },
                  filter: true,
                }),
                ...(lookup_code == 'tag_line_status' && {
                  suppressPaste: true,
                  suppressFillHandle: true,
                  suppressKeyboardEvent: (params) => {
                    return params.event.keyCode === 46 || params.event.keyCode === 8;
                  },
                  valueSetter: (params) => {
                    if (params.newValue === null || params.newValue === undefined || params.newValue === '') {
                      return false;
                    }
                    params.data.tag_line_status = params.newValue;
                    return true;
                  },
                  cellEditorSelector: (params) => {
                    if (params.data.config_status.includes("INPROCESS") || params.data.gen_costing_status == "IN PROCESS") {
                      return null; // Disable cell editor if cell is greyed out
                    }
                    return {
                      component: 'agRichSelectCellEditor',
                      popup: true,
                      params: {
                        cellHeight: 30,
                        values: tagStatusNew2,
                      }
                    };
                  },
                  filter: true,
                }),
                // ...(lookup_code == 'tag_line_status' && { suppressPaste: true, cellEditor: 'agRichSelectCellEditor', cellEditorPopup: true, filter: true, editable: writeAcc, cellEditorParams: { cellHeight: 30, values: tagStatusNew2, }, }),
                ...(numericFields.includes(lookup_code) && { valueSetter: (params) => validateNumericFields(params, lookup_code) }),
                ...(integerFields.includes(lookup_code) && { valueSetter: (params) => validateIntegerFields(params, lookup_code) }),
                ...(priceFields.includes(lookup_code) && {
                  valueSetter: (params) => validateNumericFields(params, lookup_code),
                  valueGetter: (params) => addCommas(params, lookup_code)
                }),
                ...(lookup_code === 'purchase_total_price' && { valueGetter: (params) => addCommas(params, lookup_code) }),
                // ...(lookup_code == 'pur_unit_price' && {
                //   valueGetter: (params) => {
                //     if (params.data.pur_unit_price == null) { return null }
                //     return Number(currToStr(params.data.pur_unit_price))?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                //   }
                // })
                ...(lookup_code === 'gen_rel_tag' && {
                  cellStyle: { cursor: 'pointer' },
                  valueGetter: renderRelatedTag,
                }),
                //  ...(lookup_code == 'pur_pa_id' && {valueSetter: validatePaRefIdField})
              }
            )
          }

          )
        });
      }
    }
    if (bool == false) { return result }
    setColDefinations(result)
    console.log(result, '---result---')
  }

  function createDefsChild(dataset, bool) {
    const commonField = [
      { headerName: 'Package ID', field: 'package_id', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: 'Project ID', field: 'project_id', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: 'Tag ID', field: 'tag_id', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: 'Rev', field: 'revision', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true },
      { headerName: "", field: 'sel', width: 55, filter: false, menuTabs: false, resizable: false, checkboxSelection: true, suppressMenu: true, headerCheckboxSelection: true, suppressColumnsToolPanel: true, editable: false, headerCheckboxSelectionFilteredOnly: true, pinned: 'left', lockPosition: true },
      // { headerName: "#", field: 'sno', width: 55, filter: false, menuTabs: false, resizable: true, valueGetter: getRow, suppressMenu: true, suppressColumnsToolPanel: true, editable: false },
      { headerName: 'Sr.No.', field: 'srno', filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true, valueGetter: getRow },
      // { headerName: '', field: 'icon',width: 55, filter: false, hide: false, suppressMenu: true, suppressColumnsToolPanel: true, cellRenderer: parentOrChildIcon }
    ]

    const editFalseField = ['gen_technology_type', 'gen_prod_desc', 'gen_instrument_type', 'tag_line_status', 'config_status', 'purchase_total_price', 'pur_configurator_id', 'gen_oracle_quote', 'pur_config_rev_num', 'quote_hdr_id', 'quote_line_id']
    const priceFields = ['pur_unit_list_price1', 'pur_unit_list_price2', 'pur_unit_list_price3', 'pur_unit_list_price4', 'pur_unit_list_price5', 'pur_unit_list_price6', 'pur_total_unit_price', 'purchase_total_price', 'pur_sell_list_price1', 'pur_sell_list_price2',
      'pur_sell_list_price3', 'pur_sell_list_price4', 'pur_sell_list_price5', 'pur_sell_list_price6', 'pur_total_sell_price']
    const numericFields = ['purchase_discount']
    const integerFields = ['quantity', 'request_id']

    const result = [];
    const tagObj = {};
    dataset.sort((a, b) => a.group_sequence - b.group_sequence);
    dataset.forEach((item) => {
      const { tag, group_sequence, sequence, ...rest } = item;
      if (!tagObj[tag]) {
        tagObj[tag] = [];
      }
      tagObj[tag].push({ group_sequence, sequence, ...rest });
    });

    for (const tag in tagObj) {

      const children = tagObj[tag].sort((a, b) => a.sequence - b.sequence);
      if (tag == "Common") {
        const tempChild = children.map(({ meaning, lookup_code }) =>
        ({
          headerName: meaning,
          field: lookup_code,
          ...((lookup_code == 'tag_number') && { comparator: AlphaNumericComp }),
          ...((lookup_code == 'comm_description' || lookup_code == 'comm_library_element') && { filter: false, hide: true, suppressMenu: true, suppressColumnsToolPanel: true })
        }))
        tempChild.unshift(...commonField)
        result.push({
          headerName: tag,
          children: tempChild
        });
      }

      else {
        result.push({
          headerName: tag,
          children: children.map(({ meaning, lookup_code }) => {
            let isHide = isColHiddenChild(lookup_code)
            return (
              {
                headerName: meaning,
                field: lookup_code,
                hide: isHide,
                suppressMenu: isHide,
                suppressColumnsToolPanel: isHide,
                ...(editFalseField.includes(lookup_code) && { editable: false }),
                ...(lookup_code == 'tag_line_status' && { suppressPaste: true, cellEditor: 'agRichSelectCellEditor', cellEditorPopup: true, filter: true, editable: false, cellEditorParams: { cellHeight: 30, values: tagStatusNew2, }, }),
                ...(numericFields.includes(lookup_code) && { valueSetter: (params) => validateNumericFields(params, lookup_code) }),
                ...(integerFields.includes(lookup_code) && { valueSetter: (params) => validateIntegerFields(params, lookup_code) }),
                ...(priceFields.includes(lookup_code) && {
                  valueSetter: (params) => validateNumericFields(params, lookup_code),
                  valueGetter: (params) => addCommas(params, lookup_code)
                }),
                ...(lookup_code === 'purchase_total_price' && { valueGetter: (params) => addCommas(params, lookup_code) }),
                // ...(lookup_code == 'pur_unit_price' && {
                //   valueGetter: (params) => {
                //     if (params.data.pur_unit_price == null) { return null }
                //     return Number(currToStr(params.data.pur_unit_price))?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                //   }
                // })
                ...(lookup_code === 'gen_rel_tag' && {
                  cellStyle: { cursor: 'pointer' },
                  valueGetter: renderRelatedTag,
                })
              }
            )
          }

          )
        });
      }
    }
    if (bool == false) { return result }
    setColDefinationsChild(result)
    // console.log(result, '---result---')
  }

  useEffect(() => {
    dispatch(hideProgressBar())

    if (ctrl.pkg.active_revision) {
      setActRev({ value: ctrl.pkg.active_revision, label: ctrl.pkg.active_revision })
    } else {
      setActRev({ value: ctrl.pkg.max_revision, label: ctrl.pkg.max_revision })
    }
    let optns = [{ value: 1, label: 1 }];
    let ar = ctrl.pkg.active_revision;
    for (let i = 2; i <= ctrl.pkg.max_revision; i++) {
      optns.push({ value: i, label: i, color: i == ar ? 'red' : 'black' });
    }
    setReviSelectOptn(optns);
  }, [])

  useEffect(() => {
    if (revisionState.phase === "SUCCESS") {
      dispatch(createUpdtReviPhaseAct("INIT"))
      console.log("value added")

      setTimeout(function () {
        gridApi?.deselectAll();
        gridApi?.redrawRows();
      }, 0)
    }
  }, [revisionState.phase, gridApi])


  useEffect(() => {
    let per = Math.round(fetchedDataCnt * 100 / gettagcntTl)
    setFetchtagPBarCount(per)
  }, [fetchedDataCnt, gettagcntTl]);


  // const onChangeRev = (e) =>{
  //   setTimeout(() => {
  //      setData(selDataset);
  //     }, 10);
  //   //  if(e.value!=actRev.value){
  //   //     dispatch(fetchTagCountAct({pid:ctrl.pkg.project_id, pkgid:ctrl.pkg.package_id, rev:e.value}))
  //   //     setPrevRev(actRev);
  //   //     setActRev(e);
  //   //  }
  // }

  function getWriteAcc() {
    let write_accs = tagdata.filter((item) => item.project_id === ctrl.data?.project_id && prof.email?.toUpperCase() === item.email_id?.toUpperCase())[0]?.write_access
    write_accs = ctrl.data.created_by?.toUpperCase() == prof.email?.toUpperCase() || write_accs == 'Y' ? true : false
    if (!write_accs) {
      write_accs = (profileState.capb?.findIndex((o) => o.PWSADACC === 'Y') >= 0 ? true : false);
    }
    return write_accs
  }

  useEffect(() => {
    const write_accs = getWriteAcc()
    setWriteAcc(write_accs)
  }, [tagdata, ctrl.data, profileState.capb]);

  const toggle = () => {
    setOpen(!dwOpen)
  }

  const currToStr = (str) => {
    const numericalChar = new Set([".", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]);
    str = str.toString()?.split("").filter(char => numericalChar.has(char)).join("")
    return str
  };
  const selectedNodes = gridApi?.getSelectedNodes();
  const selectData = selectedNodes?.map(node => node.data);

  const onGridReady = (params) => {
    const ftag = localStorage.getItem('TAG');
    setGridApi(params?.api);
    setGridColumnApi(params?.columnApi);
    if (ftag) {
      params.api.forEachNode((node) => {
        if (node.data.tag_number === ftag) {
          node.setSelected(true)
          params.api.ensureIndexVisible(node.rowIndex, 'middle');
        }
      })
      //
      localStorage.removeItem('TAG');

    }

  };
  // reset column state
  const resetState = () => {
    gridRef.current.columnApi?.resetColumnState();
    // Clear localStorage for all possible datasets
    techName.forEach(dataset => {
      localStorage.removeItem(dataset);
    });

    // console.log('Column state has been reset successfully.');
  };
  // clear filters
  const clearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };
  const clearFilterschild = () => {
    if (childGridApi) {
      childGridApi.setFilterModel(null);
    }
  };
  const [alreadyCount, setAlreadyCount] = useState(0);

  const onGridReadyChild = (params) => {
    setChildGridApi(params?.api);
    setGridColumnApi(params?.columnApi);
    // let count = 0;
    // params.api.forEachNode((node)=>{
    //   if(node.data?.parentChild === true){
    //     node.setSelected(true)
    //     count = count + 1
    //   }

    // })
    // setAlreadyCount(count);
  }

  const onImportGridReady = (params) => {
    setImportGridApi(params.api);
  }


  const gtTTlbl = (params) => {
    let val = getTTLabel(ctrl.techTypes, params.data.gen_instrument_type);
    return val;
  }

  const stringFormatter = (params) => {
    return params.value ? params.value.toUpperCase() : params.value
  }

  useEffect(() => {


    setSlctdPkgTags([]);
    let tempSlctdPkgTags = [];
    let tempTags = [];
    pkgs.forEach((pkg) => {
      tempTags = tags.filter(tag => pkg.package_id == tag.package_id && (tag.selected == 'Y' || tag.selected === 'Y'));
      tempSlctdPkgTags.push({ 'package': pkg, 'tags': tempTags })
    })
    // console.log(tempSlctdPkgTags);
    setSlctdPkgTags(tempSlctdPkgTags);
    //setTimeout(function () { gridApi?.refreshCells(); }, 0)

    if (dispatchTagUpdate && dispatchTagUpdate.length > 0) {

      dispatch(showLoader(false));

    }

    if (tags.length > 0) {
      // let tagDatafiltered = tags.filter(o => o.selected === 'Y').sort(sortAlphaNumTag);
      // console.log(tagDatafiltered);
      // settagDataList(tagDatafiltered)
      // gridApi?.deselectAll();
      // setTimeout(function() { gridApi.redrawRows(); }, 0)
      let tagDatafiltered = tags.filter(o => o.selected?.toUpperCase() === 'Y').sort(sortAlphaNumTag);

      settagDataList(tagDatafiltered);

      // setTimeout(() => {
      //   //gridApi?.deselectAll();
      //   //gridApi?.redrawRows();

      // }, 0);
    }
    let temptimmer = setTimeout(() => {
      // console.log("timmer");
      if (pckgCouterBadges?.current?.scrollWidth - pckgCouterBadges?.current?.clientWidth === 0) {
        setIsBadgesScrollEnbl(false)
      } else {
        setIsBadgesScrollEnbl(true)
      }
      //gridApi?.deselectAll();
      //gridApi?.redrawRows();
    }, 300);

    return () => {
      clearTimeout(temptimmer);
    }

  }, [tags]);

  useEffect(() => {
    let temptimmer = setTimeout(() => {
      gridApi?.forEachNode(node => {
        const isSelectable = isRowSelectableTagGrid({
          data: node.data
        });
        node.setRowSelectable(isSelectable);
      });
      gridApi?.deselectAll();
      gridApi?.clearRangeSelection();
      gridApi?.redrawRows();
    }, 100);

    return () => {
      clearTimeout(temptimmer);
    }

  }, [bulkUpdatedTags, itemPriceStatus])


  const onCellEditingStarted = () => {
    dispatchRow = [];
    setConfPasteEnabled(true);
    SetDphTagCount(0);
  };

  const onCellEditingStopped = () => {
    setConfPasteEnabled(false);
  };
  const onCellValueChanged = async (rec) => {
    const searchArray = ['Flow', 'DP Flow', 'DP Level'];

    if (rec.colDef.field == 'pur_pa_id' && rec.newValue && (searchArray.indexOf(rec.data.technology_name) !== -1)) {
      const sizingRes = await paGetSizingAPI(rec.newValue, rec.data.technology_name)
      if (!sizingRes?.data?.valid || sizingRes.status == 400) {
        toastr.error('Entered PA Reference ID is Invalid.')
        setTimeout(() => {
          gridApi?.undoCellEditing();
          SetdispatchTagSize(0);
          SetDphTagCount(0);
        }, 200)
        return
      }
      else if (sizingRes.status != 200) {
        toastr.error('Sorry! Something went wrong. Please try again later.')
        return
      }
    }

    if ((!dispatchTagUpdate || dispatchTagUpdate?.length <= dispatchSize) && confPasteEnabled) {
      //  if(dphTagCount <= 1){
      // setTimeout(()=>{
      // SetfreezeConfModal(true); 
      // },200)      
      if (['paste', 'rangeService'].includes(rec.source)) {
        SetfreezeConfModal(true);
      }
      SetDphTagCount(dphTagCount + 1);
      //}
      if (freezeConfModal && ['paste', 'rangeService'].includes(rec.source)) {
        SetfreezeConfModal(false);
      }
      else {
        if (!cancelActive) {
          if (dphTagCount >= 0 && !tagState?.showPkg && ['paste', 'rangeService'].includes(rec.source)) {
            // if(dphTagCount >= 0 && !tagState?.showPkg && dispatchTagUpdate){  
            SetconfPaste(true);
          }
          if (dphTagCount >= 1 && tagState?.showPkg) {

            setTimeout(() => {
              gridApi?.undoCellEditing();
              SetdispatchTagSize(0);
              SetDphTagCount(0);
            }, 200)
          }
          if (dispatchTagUpdate?.length >= dispatchSize) {
            SetShowConfirmData(true);
          }
        }
      }
      let tagExits = undefined;
      if (rec.colDef.field === 'model_name' ||
        rec.colDef.field === 'pre_config_base_model_String' ||
        rec.colDef.field === 'child_name1' ||
        rec.colDef.field === 'pre_config_sub_model1_string' ||
        rec.colDef.field === 'child_name2' ||
        rec.colDef.field === 'pre_config_sub_model2_string' ||
        rec.colDef.field === 'child_name3' ||
        rec.colDef.field === 'pre_config_sub_model3_string' ||
        rec.colDef.field === 'gen_base_model_1' ||
        rec.colDef.field === 'gen_base_model_2' ||
        rec.colDef.field === 'gen_base_model_3' ||
        rec.colDef.field === 'gen_base_model_4' ||
        rec.colDef.field === 'gen_base_model_5' ||
        rec.colDef.field === 'gen_base_model_6' ||
        rec.colDef.field === 'gen_mod_ser_part1' ||
        rec.colDef.field === 'gen_mod_ser_part2' ||
        rec.colDef.field === 'gen_mod_ser_part3' ||
        rec.colDef.field === 'gen_mod_ser_part4' ||
        rec.colDef.field === 'gen_mod_ser_part5' ||
        rec.colDef.field === 'gen_mod_ser_part6' ||
        rec.colDef.field === 'gen_mod_ser_part7' ||
        rec.colDef.field === 'pur_mod_num_part1' ||
        rec.colDef.field === 'pur_mod_num_part2' ||
        rec.colDef.field === 'pur_mod_num_part3' ||
        rec.colDef.field === 'pur_mod_num_part4' ||
        rec.colDef.field === 'pur_mod_num_part5' ||
        rec.colDef.field === 'pur_mod_num_part6' ||
        rec.colDef.field === 'pur_mod_num_part7'
      ) {
        rec.newValue = rec.newValue?.trim().toUpperCase();
      }
      // const updatedTag = checkCONFIG(rec.data, rec.colDef.field);
      //console.log(rec.colDef.field, "rec.colDef.field+++++++")
      if (changeConfigeStatus.includes(rec.colDef.field)) {
        setChangedField(rec.colDef.field);
      }
      else {
        setChangedField(null);
      }
      if (changeConfige && excludeToConfigue.includes(rec.colDef.field)) {
        SetChangeConfige(false);
      }
      if (!changeConfige && !excludeToConfigue.includes(rec.colDef.field)) {
        SetChangeConfige(true);
      }
      if (rec.colDef.field == 'tag_number') {
        if (rec.newValue === null || rec.newValue.trim() === "") {
          SetconfPaste(false);
          setTagState({
            showPkg: true,
            message: 'Tag Number cannot be empty'
          });
          rec.data.tag_number = rec.oldValue;
          setTimeout(function () { gridApi?.refreshCells(); }, 100)

          return
        }

        else {
          tagExits = tags.find(o => (o.tag_id != rec.data.tag_id && o.tag_number.toString().toLowerCase().trim() === rec.newValue.toString().toLowerCase().trim()));
          //console.log(tagExits)
          if (tagExits !== undefined) {

            SetconfPaste(false);
            setTagState({
              showPkg: true,
              message: 'Tag ' + rec.newValue + ' should be unique'
            });
            rec.data.tag_number = rec.oldValue;
            setTimeout(function () { gridApi?.refreshCells(); }, 100)

          } else {
            rec.data.tag_number = rec.newValue;
          }
        }
      }

      if (tagExits === undefined) {
        const pl = rec.data;
        if (rec.newValue !== rec.oldValue) {

          pl[rec.colDef.field] = rec.newValue;
          pl['creation_date'] = rec.data.creation_date;//getDt(new Date(rec.data.creation_date));
          pl['last_updatedby'] = prof.email;
          pl['last_updatedate'] = getDt(new Date());
          pl['proj_name'] = (ctrl.data.pdl_project_name !== null && ctrl.data.pdl_project_name !== undefined && ctrl.data.pdl_project_name.trim() !== "")
            ? ctrl.data.pdl_project_name
            : ctrl.data.project_name;

          // pl['end_date']=getDt(new Date(rec.data.end_date));
          // pl['start_date']=getDt(new Date(rec.data.start_date));
          pl['start_date'] = null;
          //pl['siz_date']= getDt(new Date(rec.data.siz_date));
          pl['selected'] = 'Y';
          // if (rec.colDef.field == 'pur_unit_price')
          //   pl['pur_unit_price'] = currToStr(rec.newValue) == '0.00' ? null : currToStr(rec.newValue)'

          // adding Total price
          let total_price = 0;
          for (let i = 1; i <= 6; i++) {
            const propName = `pur_unit_list_price${i}`
            if (pl[propName]) {
              pl[propName] = getNumber(pl[propName]).toFixed(2)
              total_price += Number(pl[propName])
            }
          }


          console.log("total_price", total_price);
          // add all unit price
          pl['pur_total_unit_price'] = total_price ? total_price.toFixed(2) : null
          // adding selling price
          let TotalSellPrice = 0;
          let finalSellPrice = 0;
          for (let i = 1; i <= 6; i++) {
            const propName = `pur_sell_list_price${i}`
            if (pl[propName]) {
              pl[propName] = getNumber(pl[propName]).toFixed(2)
              TotalSellPrice += Number(pl[propName])
            }
          }
          console.log("TotalSellPrice", TotalSellPrice);
          // add all sell price  
          pl['pur_total_sell_price'] = TotalSellPrice ? TotalSellPrice.toFixed(2) : null
          //Total Price = Qty x Total Sell Price
          if (pl.quantity) {
            finalSellPrice = TotalSellPrice * pl.quantity;
          } else {
            finalSellPrice = TotalSellPrice;
          }
          pl['purchase_total_price'] = finalSellPrice ? finalSellPrice.toFixed(2) : total_price ? (total_price * pl.quantity).toFixed(2) : null
          //    console.log(pl);
          const ifExists = (tag_id) => {
            return dispatchRow.some(function (el) {
              return el.tag_id === tag_id;
            });
          }
          if (!ifExists(pl.tag_id)) {
            dispatchRow.push(pl);
          } else {
            const index = dispatchRow.findIndex((x) => x.tag_id === pl.tag_id);
            dispatchRow[index] = pl;
          }
          SetdispatchTagUpdate(dispatchRow);
          // dispatch(updTagAct(pl))
        }

        setTimeout(function () { gridApi?.refreshCells(); }, 0)
      }

    }
    //if(!confPasteEnabled){ 
    if (!confPasteEnabled && !resMesg && 2 === 1) {
      // undo condition
      const pl = rec.data;
      pl['proj_name'] = (ctrl.data.pdl_project_name !== null && ctrl.data.pdl_project_name !== undefined && ctrl.data.pdl_project_name.trim() !== "")
        ? ctrl.data.pdl_project_name
        : ctrl.data.project_name;
      const ifExists = (tag_id) => {
        return dispatchRow.some(function (el) {
          return el.tag_id === tag_id;
        });
      }
      if (!ifExists(pl.tag_id)) {
        dispatchRow.push(pl);
      } else {
        const index = dispatchRow.findIndex((x) => x.tag_id === pl.tag_id);
        dispatchRow[index] = pl;
      }
      SetdispatchTagUpdate(dispatchRow);
    }
  }
  useEffect(() => {
    if (dispatchTagUpdate) {
      const dispatchDebounce = setTimeout(() => {
        if (!confPasteEnabled) {
          savePasteTags();
        }
        SetdispatchTagSize(dispatchTagUpdate.length);
        SetShowConfirmData(false);
        dispatchRow = [];
      }, 1000);
      return () => {
        clearTimeout(dispatchDebounce);
      }
    }
  }, [dispatchTagUpdate])


  const checkCONFIG = (tag, fieldChanged) => {
    // Check if config_status starts with specific values
    if (tag.config_status == "VAL-" + getDtfrmt(new Date())) {
      tag.config_status = "VALID-" + getDtfrmt(new Date());
    }


    // Check if the changeConfige flag is true and if the field changed is in the changeConfigeStatus array
    else if (changeConfige && tag.config_status && !nonConfigProducts.includes(tag.gen_prod_desc) && changeConfigeStatus.includes(fieldChanged)) {
      // Set config_status to UNCONFIG and update the necessary fields

      console.log(fieldChanged, "fieldChanged");
      tag.config_status = "UNCONFIG-" + getDtfrmt(new Date());
      tag.configuration_import = "NEW";
      valueToNull.forEach((colName) => {
        tag[colName] = null;
      });
      const rowNode = gridApi?.getRowNode(tag.tag_id);
      // if (rowNode) {
      //   rowNode.setData(tag);
      // }
      return tag;
    }
    else {
      SetChangeConfige(true);
      return tag;
    }
  };
  const cancelPasteTags = () => {
    SetShowConfirmData(false);
    SetconfPaste(false);
    SetfreezeConfModal(true);
    SetCancelActive(true);
    setConfPasteEnabled(true);
    dispatchRow = [];
    setTimeout(() => {
      SetdispatchTagSize(0);
      SetDphTagCount(0);
      SetdispatchTagUpdate(null);
    }, 200)
    gridApi.undoCellEditing();

  }
  useEffect(() => {
    if (dispatchTagUpdate) {
      const dispatchDebounce = setTimeout(() => {
        if (dphTagCount == 1 && dispatchTagUpdate?.length === 1 && !confPaste) {
          //  if(dphTagCount == 0 && dispatchTagUpdate?.length === 0){
          let tag = dispatchTagUpdate[0];
          tag = checkCONFIG(tag, changedField);
          dispatch(updTagAct(tag));
          SetDphTagCount(0);
          SetdispatchTagUpdate(null);
          SetShowConfirmData(false);
          dispatchRow = [];
          setFindTagFilter(true);
          setConfPasteEnabled(false);
          setChangedField(null);
          gridApi?.refreshCells();

        }
      }, 10);
      return () => {
        clearTimeout(dispatchDebounce);
      }
    }
  }, [dphTagCount, dispatchTagUpdate])

  useEffect(() => {
    if (resMesg) {
      gridApi.undoCellEditing();
      dispatch(showLoader(false));
      // toastr.error("resMesg");
      toastr.error(t('TAG data is too large, Please Verify!'))
    }

    setTimeout(() => {
      dispatch(delTagRes());
    }, 500)

  }, [resMesg])

  useEffect(() => {
    setTimeout(() => {
      SetCancelActive(false);
    }, 500)
  }, [cancelActive])


  const startCellEditing = () => {

    dispatchRow = [];
    if (!confPasteEnabled) {
      setConfPasteEnabled(true);
    }
    if (dphTagCount > 0) {
      SetfreezeConfModal(false);
      SetdispatchTagSize(0);
      SetDphTagCount(0);
      SetdispatchTagUpdate(null);
    }
  }

  document.addEventListener("paste", (event) => {
    startCellEditing();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Delete") {
      startCellEditing();
    }
  });


  const savePasteTags = () => {
    if (dispatchTagUpdate) {
      if (dispatchTagUpdate?.length > 1) {
        dispatch(showLoader(true));
      }
      dispatchTagUpdate.map((tag, i) => {
        if (i <= (dispatchSize - 1)) {
          setTimeout(() => {
            tag = checkCONFIG(tag, changedField);
            dispatch(updTagAct(tag));
          }, 200 * i);
        }
      })
    }
    setConfPasteEnabled(false);
    setFindTagFilter(true);
    SetDphTagCount(0);
    SetconfPaste(false);

  }

  // useEffect(() => {
  //   if (dispatchTagUpdate && dispatchTagUpdate.length > 0) {

  //     dispatch(showLoader(false));

  //   }

  // }, [tags])

  useEffect(() => {
    if (findTagVal && findTagFilter) {
      setFindTagVal(props.findTag);
      let res = filterArray(tagDataList, props.findTag);
      setParentTableData(res);
      setFindTagFilter(false);
    }
  }, [parentTableData])

  // useEffect(() => {
  //   console.log("gridRef.current", gridRef.current)
  //   if (gridRef.current) {
  //     console.log("under ifffff state restore")
  //     restoreState()
  //   }
  // }, [gridRef])
  useEffect(() => {
    if (gridRef.current) {
      console.log("Restoring state...");
      restoreState();
    } else {
      console.warn("gridRef is not ready. Retrying...");
      setTimeout(() => restoreState(), 100);
    }
  }, [gridRef]);

  // const setLocalStorage = (data, key = selDataset) => {
  //   // console.log("data",data,key)

  //   localStorage.setItem(key, JSON.stringify(data));
  // }

  const getLocalStorage = (key = selDataset) => {
    return JSON.parse(localStorage.getItem(key));
  }

  // const clearLocalStorage = () => {
  //   localStorage.clear();
  // }

  // const saveState = () => {
  //   // window.colState = gridRef.current.columnApi.getColumnState();
  //   const colState = gridRef.current.columnApi?.getColumnState();
  //   setLocalStorage(colState);

  //   console.log('column state saved');
  // };
  const saveState = () => {
    const colState = gridRef.current.columnApi?.getColumnState();
    if (!colState) {
      // console.warn("No column state to save.");
      return;
    }
    // setLocalStorage(colState);
    // console.log("Column state saved:", colState);
  };

  const restoreState = useCallback(() => {
    const colState = getLocalStorage();
    // const colState = window.colState
    console.log("colstate", colState)
    if (!colState) {
      console.log('no columns state to restore by, you must save state first');
      return;
    }

    setTimeout(() => {
      gridRef.current.columnApi?.applyColumnState({
        state: colState,
        applyOrder: true,
      });
    }, 10)
    console.log("gridRef.current.columnApi", gridRef.current.columnApi?.applyColumnState)
    console.log('column state restored');
  }, []);




  const configLine = () => {
    gridApi.stopEditing()
    let selectedNodes = gridApi.getSelectedNodes();
    let selectedData = selectedNodes.map(node => node.data);
    if (selectedData.length == 0) {
      toastr.error(t('Please Select the Tag line'))
    }
    else if (selectedData.length > 1) {
      toastr.error(t('Please select only one tag line'))
    }
    else if (nonConfigProducts.includes(selectedData[0].gen_prod_desc)) {
      toastr.error(t('Selected type is not Configurable'))
    }
    //check the association of parent with child
    // else if (selectedData[0].tag_id === selectedData[0].parent_tag_id) {
    //   toastr.error(`${selectedData[0].tag_number} 
    // has been copied to other tags. Please remove the association before continuing.`)
    // }
    //check the association of child with parent
    // else if (selectedData[0].parent_tag_id) {
    //   setRemoveChildAssociation({
    //     showConfirmation: true,
    //     message: ` ${selectedData[0].tag_number} has associated sizing/configuration. would you like to continue?`
    //   })
    // }
    else if ((selectedData[0].gen_base_model_1 == null || selectedData[0].gen_base_model_1 == "")
      && (selectedData[0].ord_it_assembly_model == null || selectedData[0].ord_it_assembly_model == "")) {
      toastr.error(t('Please select Base Model 1 or Assembly Model'))
    }
    else if (selectedData[0].division_code === null || selectedData[0].division_code === "") {
      toastr.error(t('Please select the Product Group'))
    }
    else {
      localStorage.setItem('TAG', selectedData[0].tag_number)
      dispatch(assignTags(selectedData[0], gridApi.getColumnDefs()))
      //gridApi.refreshCells();                 
      //console.log(selectedNodes)
      // history.push('/config')
      navigate('/config')
      saveState();
    }
  }

  const addPackageComments = () => {
    if (!revComments.trim()) {
      toastr.error(t('Please enter a revision comment'));
      return;
    }

    commentScrollTopRef.current = commentDialogContentRef.current?.scrollTop ?? 0;

    const payload = {
      "project_id": ctrl.pkg.project_id,
      "package_id": ctrl.pkg.package_id,
      "package_name": ctrl.pkg.package_name,
      "project_name": ctrl.data.project_name,
      "revision_number": +slctRev.value,
      "revision_comments": revComments.trim()
    }

    dispatch(updatePkgCmntStart(payload));
    setRevComments('');
  }

  const startNewComment = () => {
    setEditingCommentId(null);
    setRevComments('');
    setInlineEditMap({});
    setOpenCmtConfirm(true);
  }

  const handleEditComment = (commentItem) => {
    setEditingCommentId(commentItem.revision_id);
    setInlineEditMap((prev) => ({
      ...prev,
      [commentItem.revision_id]: commentItem.revision_comments || ''
    }));
  }

  const handleInlineEditChange = (revisionId, value) => {
    setInlineEditMap((prev) => ({ ...prev, [revisionId]: value }));
  }

  const cancelInlineEdit = (revisionId) => {
    setEditingCommentId(null);
    setInlineEditMap((prev) => {
      const next = { ...prev };
      delete next[revisionId];
      return next;
    });
  }

  const saveInlineEdit = (commentItem) => {
    const updatedComment = (inlineEditMap[commentItem.revision_id] || '').trim();
    if (!updatedComment) {
      toastr.error(t('Please enter a revision comment'));
      return;
    }

    commentScrollTopRef.current = commentDialogContentRef.current?.scrollTop ?? 0;

    const payload = {
      "project_id": ctrl.pkg.project_id,
      "package_id": ctrl.pkg.package_id,
      "package_name": ctrl.pkg.package_name,
      "project_name": ctrl.data.project_name,
      "revision_number": +slctRev.value,
      "revision_comments": updatedComment,
      "revision_id": commentItem.revision_id
    }

    dispatch(editPkgCmntStart(payload));
    cancelInlineEdit(commentItem.revision_id);
  }

  const openDeleteCommentConfirm = (commentItem) => {
    setCommentToDelete(commentItem);
    setCommentDeleteConfirmOpen(true);
  }

  const confirmDeleteComment = () => {
    if (!commentToDelete) return;

    commentScrollTopRef.current = commentDialogContentRef.current?.scrollTop ?? 0;

    const payload = {
      "project_id": ctrl.pkg.project_id,
      "package_id": ctrl.pkg.package_id,
      "package_name": ctrl.pkg.package_name,
      "project_name": ctrl.data.project_name,
      "revision_number": +slctRev.value,
      "revision_comments": commentToDelete.revision_comments,
      "revision_id": commentToDelete.revision_id,
      "enabled_flag": "N"
    }
    dispatch(editPkgCmntStart(payload));
    setCommentDeleteConfirmOpen(false);
    setCommentToDelete(null);
  }

  const cancelDeleteCommentConfirm = () => {
    setCommentDeleteConfirmOpen(false);
    setCommentToDelete(null);
  }


  const sizeTag = () => {
    gridApi.stopEditing()
    let selectedNodes = gridApi.getSelectedNodes();
    let tempSno = selectedNodes.length && selectedNodes[0].rowIndex + 1;
    let selectedData = selectedNodes.map(node => node.data);
    if (selectedData.length == 0) {
      toastr.error(t('Please Select the Tag line'))
    }
    else if (selectedData[0].division_code === null) {
      toastr.error(t('Please select the division'))
    }
    else if (selectedData.length > 1) {
      toastr.error(t('Please select only one tag line'))
    }
    //check the association of parent with child
    // else if ((selectedData[0].tag_id && selectedData[0].parent_tag_id) && selectedData[0].tag_id === selectedData[0].parent_tag_id) {
    //   toastr.error(`${selectedData[0].tag_number} 
    // has been copied to other tags. Please remove the association before continuing.`)
    // }
    //check the association of child with parent
    // else if ((selectedData[0].tag_id && selectedData[0].parent_tag_id) && selectedData[0].tag_id !== selectedData[0].parent_tag_id) {
    //   setRemoveChildAssociation({
    //     showConfirmation: true,
    //     message: ` ${selectedData[0].tag_number} has associated 
    //     sizing/configuration. would you like to continue?`
    //   })
    // }
    //condition for ticket no 1158557
    else if (!["DP Flow", "Flow", "DP Level"].includes(selectedData[0].gen_technology_type)) {
      toastr.error(t('No Product Advisor Available. Use alternate Size and Selection process/tool.'))
    }
    else {
      localStorage.setItem('TAG', selectedData[0].tag_number)
      selectedData[0].sno = tempSno
      dispatch(assignTags(selectedData[0], gridApi.getColumnDefs()))
      //gridApi.refreshCells();            
      // history.push('/size')
      navigate('/size')
      saveState();
    }
  }

  const onClickLinkTag = () => {
    if (selectedRowsData.length === 0) {
      toastr.error(t('Please select a line'))
      return
    }
    if (selectedRowsData.length != 1) {
      toastr.error(t('Please select only one line'))
      return
    }

    setIsLinkTagOpen(true)
  }


  const getRow = (params) => {
    return params.node.rowIndex + 1;
  };

  const getTechType = (params) => {
    return params.data.technology_name;
  };

  function getFilteredSelectedRows(gridApi) {
    const selected = [];
    const displayedRows = gridApi.getDisplayedRowCount();
    for (let i = 0; i < displayedRows; i++) {
      const rowNode = gridApi.getDisplayedRowAtIndex(i);
      if (rowNode && rowNode.isSelected()) {
        selected.push(rowNode.data);
      }
    }
    return selected;
  }

  const isGtechTypsAllYN = () => {
    let slct = 0;
    gtechTyps.forEach((gtt) => {
      if (gtt.selected === 'Y') slct++;
    })
    return slct === 0 || slct === gtechTyps.length;
  }
  const gtechTypsAllYN = isGtechTypsAllYN();

  const isColHidden = (colField) => {

    // Check userPreference first
    if (userPreference && userPreference.preference_key === 'tagworkspace') {
      // debugger
      if (userPreference?.columns) {
        // First try to find in direct columns
        let preferenceColumns = userPreference.columns[selDataset];

        // If not found, try in Instrumentation
        if (!preferenceColumns && userPreference.columns.Instrumentation) {
          preferenceColumns = userPreference.columns.Instrumentation[selDataset];
        }

        if (preferenceColumns.length && Array.isArray(preferenceColumns)) {
          const prefCol = preferenceColumns.find(col => col.column_name === colField);
          if (prefCol) {
            // Column is in preferences - map is_visible (boolean) to hide
            // is_visible can be true/false or 'Y'/'N'
            return prefCol.is_visible === true || prefCol.is_visible === 'Y' ? false : true;
          } else {
            // Column is NOT in preferences - hide it
            return true;
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }

    if (selDataset == 'Common' || !isInstrumentationTab) return false

    // const tempCols = selDataset == 'DP Flow' ? [...dpFlowLkp] 
    // : selDataset == 'Flow' ? [...flowLkp] 
    // : selDataset == 'Pressure' ? [...pressureLkp] 
    // : selDataset == 'Temperature' ? [...temperatureLkp] 
    // : selDataset == 'Process Level' ? [...processLevelLkp] 
    // : selDataset == 'DP Level' ? [...dpLevelLkp] 
    // : []

    const tempCols = lookupTables[selDataset] ? [...lookupTables[selDataset]] : [];
    const column = tempCols.find(i => i.lookup_code == colField)
    if (column == null) return true

    const ftechTyps = gtechTyps.filter((o) => o.project_id == ctrl.pkg.project_id && o.package_id == ctrl.pkg.package_id)
    let isHide = true
    const attArr = column.attribute1.split(';')
    attArr.forEach(att => {
      let attVal = att.split(':')
      let attPD = attVal[0].trim()
      let attPDVal = techTyps.find(i => i.lookup_code.trim() == attPD)?.description
      let attActive = attVal[1] == 'Y' ? true : false
      let tType = ftechTyps.find((tT) => tT.product_description == attPDVal);
      if (tType?.selected == 'Y' && attActive) {
        isHide = false;
      }

    })

    return isHide
  }

  const isColHiddenChild = (colField) => {
    // console.log('inside is hide')
    let type = selectedRowsData && selectedRowsData[0]?.gen_technology_type;
    if (type == 'Common') return false

    // const tempCols = selDataset == 'DP Flow' ? [...dpFlowLkp] 
    // : selDataset == 'Flow' ? [...flowLkp] 
    // : selDataset == 'Pressure' ? [...pressureLkp] 
    // : selDataset == 'Temperature' ? [...temperatureLkp] 
    // : selDataset == 'Process Level' ? [...processLevelLkp] 
    // : selDataset == 'DP Level' ? [...dpLevelLkp] 
    // : []

    const tempCols = lookupTables[type] ? [...lookupTables[type]] : [];
    const column = tempCols.find(i => i.lookup_code == colField)
    if (column == null) return true

    const ftechTyps = gtechTyps.filter((o) => o.project_id == ctrl.pkg.project_id && o.package_id == ctrl.pkg.package_id)
    let isHide = true
    const attArr = column.attribute1.split(';')
    attArr.forEach(att => {
      let attVal = att.split(':')
      let attPD = attVal[0]
      let attPDVal = techTyps.filter(i => i.lookup_code == attPD)[0].description
      let attActive = attVal[1] == 'Y' ? true : false
      let tType = ftechTyps.find((tT) => tT.product_description == attPDVal);
      if (tType?.selected == 'Y' && attActive) {
        isHide = false;
      }

    })

    return isHide
  }

  const configDet = () => {
    gridApi?.refreshCells();
    let selectedNodes = gridApi.getSelectedNodes();
    let selectedData = selectedNodes.map(node => node.data);
    // console.log(selectedData, "selectedData");

    if (selectedData.length === 0) {
      toastr.error(t('Please select the Tag Lines'));
      return;
    }


    let invalidTags = [];
    let validTags = [];
    console.log(selectedData);
    for (const tag of selectedData) {
      gridApi?.refreshCells();
      if (tag.config_status.split("-")[0] === "UNCONFIG" || tag.configuration_import !== "SUCCESS") {
        invalidTags.push(tag.tag_number);
      } else {
        validTags.push(tag);
      }
    }



    if (selectedData.length === 1) {
      const singleTag = selectedData[0];
      // console.log(singleTag,"singleTag")
      if (singleTag.config_status.split("-")[0] === "VALID" || singleTag.config_status.split("-")[0] === "INVALID" || singleTag.config_status.split("-")[0] === "INVAL-PRICE") {
        if (singleTag.configuration_import === "IN PROGRESS") {
          toastr.error(t('Configuration Details Import Status is IN PROGRESS, Please try after some time.'));
          return;
        }
        else if (singleTag.configuration_import === "FAILURE") {
          toastr.error(t('Configuration Details Import Status FAILED, Please reconfigure the tag.'));
          selectedNodes.forEach(node => node.setSelected(false));
          return;
        }
        else if (singleTag.configuration_import === "NEW") {

          toastr.error(t('Configuration Details Import Status is NEW, Please reconfigure the tag.'));
          return;
        }
      }
    }
    console.log("invalidTags", invalidTags);
    if (invalidTags.length === selectedData.length) {
      toastr.error(t('Please select tags with VALID/ INVALID/ INVAL-PRICE Configuration Status and Successful Configuration Import.'));
      selectedNodes.forEach(node => node.setSelected(false));
      return;
    }
    if (invalidTags.length > 0) {
      selectedNodes.forEach(node => {
        if (invalidTags.includes(node.data.tag_number)) {
          node.setSelected(false);
        }
      });
      setConfirmationPopup1(true);
    } else {
      dispatch(assignTags(selectedData, gridApi.getColumnDefs()));
      navigate('/config-detail');
    }
  };

  //-------pricing code start---------


  const pricingbtn = async () => {

    const filteredData = tags.filter(tags => tags.config_status.split("-")[0] == "VALID" && tags.gen_costing_status !== "IN PROCESS");
    console.log('pricingbtn', filteredData);
    if (filteredData.length === 0) {
      toastr.error(t('No New Valid Tags to Import'));
      return;
    }
    else {
      dispatch(postpricingdatastart(filteredData))
    }

  };
  //-----close pricing--------------------

  //----for ppa url----------------------
  const handleLinkClick = () => {

    const package_id = ctrl.pkg.package_id;
    const project_id = ctrl.pkg.project_id;
    const created_by = profileState.email; //value shld be the value of who imported the tag
    const url = `https://ppa-app-dev.azurewebsites.net/CostingWorkspace?email_id=${created_by}&project_id=${project_id}&package_id=${package_id}`; // for user
    window.open(url, '_blank');

    //setConfirmationPopup2(true);
    toastr.success("Launched PPA Successfully");
  }
  //---------------close-------------------

  const bothPPA = () => {
    //const filteredData =tags.filter(tags => tags.config_status.split("-")[0] == "VALID" && tags.gen_costing_status !== "IN PROCESS");
    pricingbtn();
    setConfirmationPopup3(true);
    // setConfirmationPopup3(pricingbtn() ? true : false);

  }

  // const closePopUp = () => 
  // {
  //    document.getElementById("bothPPA").style.display = "none";         
  // }



  const handleConfirmationYes = () => {
    // Perform the action (e.g., navigating to the config detail page) here
    //working 13march
    let selectedNodes = gridApi.getSelectedNodes();
    let selectedData = selectedNodes.map(node => node.data);
    dispatch(assignTags(selectedData, gridApi.getColumnDefs()));
    //console.log("selectedDatahandle",selectedData)
    navigate('/config-detail');

    // Close the confirmation popup
    setConfirmationPopup1(false);
  };




  const AlphaNumericComp = (valueA = '', valueB = '') => {
    const valueALower = valueA.toLowerCase();
    const valueBLower = valueB.toLowerCase();
    return valueALower.localeCompare(valueBLower, 'en', { numeric: true });
  }

  const parentOrChildIcon = (prms) => {
    if (prms.data.parent_tag_id === prms.data.tag_id) {
      return <IoDuplicate className='icn' style={{ marginLeft: '-10px' }}></IoDuplicate>
    } else if (prms.data.parent_tag_id) {
      return <IoCheckmarkDoneSharp className='icn' style={{ marginLeft: '-10px' }}></IoCheckmarkDoneSharp>
    } else {
      return null;
    }
  }

  let gridDefinition = useMemo(() => {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: ffActive,
        sortingOrder: ["asc", "desc", ""],
        editable: (params) => (!params?.data?.config_status?.includes("INPROCESS") && params?.data?.gen_costing_status != "IN PROCESS") && isCellEditable,

        filterParams: {
          // buttons: ['apply', 'cancel'],
          closeOnApply: true,
          tooltipComponent: CustomTooltip,
        },
        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        cellClass: (params) => (params?.data?.config_status?.includes("INPROCESS") || params?.data?.gen_costing_status == "IN PROCESS") && "custom-class-ne",
        tooltipComponent: CustomTooltip,
        tooltipComponentParams: (params) => params.data?.config_status?.includes("INPROCESS") && !commercialTypes.includes(params.data?.gen_technology_type) ? { text: `Bulk Configuration in progress by ${params.data?.bulk_conf_request_by}` } : null,
        tooltipValueGetter: (params) => params.data?.config_status?.includes("INPROCESS") && !commercialTypes.includes(params.data?.gen_technology_type) ? `Bulk Configuration in progress by ${params.data?.bulk_conf_request_by}` : null,
      },
      rowClassRules: {
        'projectgrid-alternaterows': function (data) { return (data.node.rowIndex % 2 === 1) }
      }
    }
  }, [isCellEditable, ffActive])

  const gridOptions = {
    statusBar: statusBar,
    sideBar: {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            // rowGroup: true,
            //suppressDragLeaveHidesColumns: false,
            //  suppressColumnFilter: true,
            // suppressColumnSelectAll: true,
            //  suppressColumnExpandAll: true,
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
        },


      ],

    },
  };
  let gridDefinitionChild = {
    defaultColDef: {
      sortable: true, resizable: true, filter: true, editable: false,
      sortingOrder: ["asc", "desc", ""], filterParams: {
        // excelMode: 'windows',
        buttons: [t('apply'), t('cancel')],
        closeOnApply: true,
        //cellStyle: {fontSize: '3px'}
      },
      // menuTabs: ['filterMenuTab', 'generalMenuTab'],
      menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    },
    rowClassRules: {
      'projectgrid-alternaterows': function (data) { return (data.node.rowIndex % 2 === 1) }
    }
  }

  const handlePkgSlctn = (pkg) => {
    const uPkg = {
      package_id: pkg.package_id,
      selected: false
    }
    dispatch(switchPkgTags(uPkg));
  }

  const handleTechSlctn = (pkg) => {
    const uPkg = {
      package_id: pkg.package_id,
      technology_id: pkg.technology_id,
      selected: false
    }
    dispatch(switchTTTagAct(uPkg))
  }

  const handlePkgsSlctn = (pkgs) => {
    pkgs.forEach((pkg) => {
      handlePkgSlctn(pkg);
    })
  }
  const onClickCell = (e) => {
    if (e.colDef.field === "tag_number") {
      //  eProj.showTags=true;
      //         eProj.data=e.data;
      //       setProj(eProj)
      //     dispatch(showTags(eProj))
      //   dispatch(showLoader(true))
      // history.push('/config')
      navigate('/config')
      //dispatch(showLoader(false))
      // dispatch(fetchPkgAct({aid:e.data.project_id}))
      //dispatch(fetchTagsAct({aid:e.data.project_id}))
    }
  }

  const togglePkgModal = () => {
    setTagState({ showPkg: false, message: null })
  }

  // ------Rahul's work start------------

  const isModified = (params) => {
    // && params.value !==null
    if (tags.some(elem => elem.tag_number === params.data.tag_number && elem[params.colDef.field] !== params.value)) {
      //mark police cells as red

      setNewAddedRowImprtGrd(prev => [...prev, params.data.tag_number]);

      return { backgroundColor: 'yellow' };
    }
    return null;
  }

  // const alltagBadge = slctdPkgTags !== null && slctdPkgTags !== undefined && slctdPkgTags.length > 0 &&
  //   slctdPkgTags.map((elem, index) => {

  //     if (elem.tags.length > 0) {
  //       return <div className='pckg-counter-item-div' key={index} style={{ position: 'relative' }}>
  //         <span style={{ color: '#00aa7e', marginRight: 12 }}> {t('All')} ({elem.tags.length}) </span>
  //         <MdClose className='pckg-counter-close-btn' onClick={() => handlePkgSlctn(elem.package)} />
  //       </div>
  //     }
  //   }
  //   )

  const AllTagBadge = () => {
    if (tagDataList.length > 0) {
      return (
        <div className='pckg-counter-item-div' style={{ position: 'relative' }}>
          <span style={{ color: COLORS.green, marginRight: 12 }}> {t('All')} ({tagDataList.length}) </span>
          <MdClose className='pckg-counter-close-btn' onClick={() => handlePkgSlctn({ package_id: tagDataList[0].package_id })} />
        </div>)
    }
  }

  // const allTesttagBadge = aa.map((elem, index) => {


  //    return <div className='pckg-counter-item-div' key={index} style={{ position: 'relative' }}>
  //       <span style={{ color: '#00aa7e', marginRight: 12 }}>test ({elem.name}) </span>
  //       <MdClose className='pckg-counter-close-btn' onClick={() => handlePkgSlctn(elem.package)} />
  //    </div>

  // }
  // )


  const isRowSelectable = useMemo(() => {
    return (params) => {
      return !tags.some(elem => elem.tag_number === params.data.tag_number) || newAddedRowImprtGrd.some(elem => elem === params.data.tag_number)

    };
  }, [newAddedRowImprtGrd, tags]);

  // const getRowStyle = useMemo(() => {
  //   return (params) => {
  //     if (!tags.some(elem => elem.tag_number === params.data.tag_number)) {
  //       return { background: '#dbf7d1' };
  //     }
  //     //  if (newAddedRowImprtGrd.some(elem => (elem.tag_number === params.data.tag_number))) {
  //     //     return { background: '#f0f8c1' };
  //     //  }
  //   };
  // }, [tags]);

  const excelStyles = useMemo(() => {
    return [
      {
        id: 'cell',
        alignment: {
          horizontal: 'Center',
          vertical: 'Center',
        },
        borders: {
          borderBottom: {
            lineStyle: 'Dot',
            weight: 1,
          },
          borderRight: {
            lineStyle: 'Dot',
            weight: 1,
          },
          borderLeft: {
            lineStyle: 'Dot',
            weight: 1,
          }
        }
      },
      {
        id: 'header',
        alignment: {
          horizontal: 'Center',
          vertical: 'Center',
        },
        font: {
          //fontName: 'Calibri Light',
          color: '#ffffff',
          bold: true,
        },
        interior: {
          color: '#000000',
          pattern: 'Solid',
        },
        borders: {
          borderTop: {
            color: '#ffffff',
            lineStyle: 'Continuous',
            weight: 1,
          },
          borderBottom: {
            color: '#ffffff',
            lineStyle: 'Continuous',
            weight: 1,
          },
          borderLeft: {
            color: '#ffffff',
            lineStyle: 'Continuous',
            weight: 1,
          },
          borderRight: {
            color: '#ffffff',
            lineStyle: 'Continuous',
            weight: 1,
          },
        },
      },
      {
        id: 'topHeader',
        alignment: {
          horizontal: 'Center',
          vertical: 'Center',
        },
        font: {
          //fontName: 'Calibri Light',
          color: '#000000',
          bold: true,
          size: 24
        },
        interior: {
          color: '#ffffff',
          pattern: 'Solid',
        },
      },
      {
        id: 'secHeader',
        alignment: {
          horizontal: 'Center',
          vertical: 'Center',
        },
        font: {
          //fontName: 'Calibri Light',
          color: '#ffffff',
          bold: true,
          size: 18
        },
        interior: {
          color: '#000000',
          pattern: 'Solid',
        },
        borders: {
          borderLeft: {
            color: '#ffffff',
            lineStyle: 'Continuous',
            weight: 1,
          },
          borderRight: {
            color: '#ffffff',
            lineStyle: 'Continuous',
            weight: 1,
          },
        },
      },

    ];
  }, []);

  const exportGrid = () => {
    setSaveStateBOl(false)
    saveState()
    // setTimeout(() => {
    //   setData(selDataset);
    // }, 10);
    var products = {};
    gridRef.current.api.forEachNodeAfterFilterAndSort(function (node) {
      const product = node.data?.gen_prod_desc;
      if (product && !products[product]) {
        products[product] = true;
      }
    });


    const productFilterInstance = gridRef.current.api.getFilterInstance('gen_prod_desc');

    var spreadsheets = [];
    for (var product in products) {
      let techName = techTyps.filter(i => i.description == product).map(i => i.category)[0]
      // console.log("techName",techName)
      // const tempTtColumn = techName == 'DP Flow' ? [...dpFlowLkp] 
      // : techName == 'Flow' ? [...flowLkp] 
      // :techName == 'Pressure' ? [...pressureLkp]
      // :techName == 'Temperature' ? [...pressureLkp]
      // :techName == 'Process Level' ? [...pressureLkp]
      // :techName == 'DP Level' ? [...pressureLkp]
      // : [...commonLkp]
      const tempTtColumn = lookupTables[techName] ? [...lookupTables[techName]] : [];
      //console.log("tempTtColumn",tempTtColumn)
      const tempColDef = createDefs(tempTtColumn, false)
      gridRef.current.api.setColumnDefs(tempColDef)
      productFilterInstance.setModel({ type: 'equals', filter: product });

      let validFields = [];
      tempTtColumn.forEach((ele) => {
        let product_code = techTyps.filter(i => i.description == product)[0].lookup_code
        // console.log("product_code",product_code)

        let attArr = ele.attribute1.split(';')
        if (attArr.includes(`${product_code}:Y`)) {
          validFields.push(ele)
        }
      })

      gridRef.current.api.onFilterChanged();

      let columnsToBeShown = [];
      if (validFields.length > 0) {
        columnsToBeShown.push('srno')
        validFields.forEach(e => {
          if (!(e.lookup_code == 'comm_library_element' || e.lookup_code == 'comm_description')) {
            columnsToBeShown.push(e.lookup_code)
          }
        });
      } else {
        columnsToBeShown = ["tag_number"];
      }

      let extraHeaders = [
        {
          cells: [
            { data: { value: product.toUpperCase(), type: "String" }, mergeAcross: columnsToBeShown.length - 1, styleId: "topHeader" },
          ],
        },
        {
          cells: [
            { data: { value: "INSTRUMENT SPECIFICATION", type: "String" }, mergeAcross: Math.floor(columnsToBeShown.length / 2) - 1, styleId: "secHeader" },
            { data: { value: "EMERSON OFFER", type: "String" }, mergeAcross: Math.ceil(columnsToBeShown.length / 2) - 1, styleId: "secHeader" },
          ],
        },
      ];

      const sheet = gridRef.current.api.getSheetDataForExcel({
        sheetName: product,
        headerRowHeight: 50,
        columnKeys: columnsToBeShown,
        prependContent: extraHeaders,
        skipColumnGroupHeaders: true,
      });

      if (sheet) {
        spreadsheets.push(sheet);
      }


    }

    const params = {
      data: spreadsheets,
      fileName: `${ctrl.data.pdl_project_name ? ctrl.data.pdl_project_name : ctrl.data.project_name}-${ctrl.pkg.package_name}-${ctrl.pkg.package_number}.xlsx`,
    }

    productFilterInstance.setModel(null);
    gridRef.current.api.onFilterChanged();
    gridRef.current.api.exportMultipleSheetsAsExcel(params);
    spreadsheets = [];

    const tempTtColumn = lookupTables[selDataset] ? [...lookupTables[selDataset]] : [];
    const tempColDef = createDefs(tempTtColumn, false)

    gridRef.current.api.setColumnDefs(tempColDef)
  }


  // function getDifference(array1, array2) {
  //    return array1.filter(object1 => {
  //       return !array2.some(object2 => {
  //          return object1.tag_number === object2.tag_number;
  //       });
  //    });
  // }
  // function getDifferenceObj(array1, array2) {
  //    let arry = [];
  //    // console.log("key_importEle")
  //    array1.forEach(importEle => {

  //       array2.forEach(dataEle => {
  //          if (importEle.tag_number !== dataEle.tag_number) { return }
  //          for (var key_importEle in importEle) {
  //             for (var key_dataEle in dataEle) {
  //                if ((key_importEle == key_dataEle) && (importEle[key_importEle] !== dataEle[key_dataEle])) {

  //                   importEle["modified_column"] = [...importEle["modified_column"], key_importEle]
  //                }

  //             }

  //          }

  //       })
  //       arry.push(importEle)

  //    })
  //    return arry

  // }


  let onRowSelectionChanged = (event) => {
    setSelectedImportGrdRow(event.api.getSelectedRows())
  }

  useEffect(() => {

    const updateSelectable = (rowNode) => {
      rowNode.setRowSelectable(isRowSelectable(rowNode));
    };

    // criterial.current = !criterial.current;
    if (importGridApi) {
      setTimeout(function () {
        grid_ImportFileRef.current.api.deselectAll();
        grid_ImportFileRef.current.api.forEachNodeAfterFilterAndSort(updateSelectable);
      }, 0)
    }

  }, [newAddedRowImprtGrd])

  const handleMergeClick = () => {

    let data1 = [...tags];
    if (!selectedImportGrdRow) { return }
    selectedImportGrdRow.forEach((e) => {
      let ignoredObj = []
      data1.forEach((el, i) => {

        if (e.tag_number === el.tag_number) {

          data1[i] = { ...el, ...e }
          ignoredObj.push(el);

        }

      })
      if (ignoredObj.length == 0) {
        data1 = [...data1, e]
      }

    })


    setTimeout(function () {
      grid_ImportFileRef?.redrawRows();
      gridApi?.redrawRows();
    }, 0)
    //dispatch(mergeImportTags(data1))

  }

  const tagStyle = {
    option: (base, state) => ({
      ...base,
      height: 35,
      minHeight: 35,
      "&:hover": {
        backgroundColor: COLORS.green,
        color: "#000"
      },
      backgroundColor: state.isSelected ? COLORS.green : '#fff',
    })
  }




  const toggleStatus = () => {
    setdwStatusOpen(!dwStatusOpen);
    settsActnVal(null);
    settsValL1(null);
    settsValL2(null);
  }
  // const [selectedRowsData, setSelectedRowsData] = useState();
  // const onSelectionChanged = (event) => {
  //   setSelectedRowsData(event.api.getSelectedRows());
  // }
  // const onSelectionChangedCopyConf = (event) => {
  //   setSelectedRowsDataCopyConf(event.api.getSelectedRows());
  //   let tempSelectedData = event.api.getSelectedRows();
  //   if (tempSelectedData.length >= 1 && tempSelectedData.length <= 20) {
  //     setCopyConfDisableBtn(false);
  //   } else {
  //     setCopyConfDisableBtn(true);
  //   }
  //   if (tempSelectedData.length > 20) {
  //     toastr.error("You can select maximum 20 records.")
  //   }
  // }

  const findWhichElementIsNotExists = (ar1, ar2) => {
    return ar1.filter(
      function (i) {
        return this.indexOf(i) < 0;
      },
      ar2
    );
  }

  // const findNewSelectedObj = (array) => {
  //   let arr = [];
  //   array.map ((item)=>{
  //     if (!item.parentChild) {
  //       arr.push(item);
  //     }
  //   });
  //   return arr;
  // }

  const onSelectionChangedCopySizing = (event) => {
    setSelectedRowsDataCopy(event.api.getSelectedRows());
    // let tempSelectedData = event.api.getSelectedRows();
    const displayedRows = event.api.getDisplayedRowCount();
    const orderedSelectedTags = [];

    // Iterate through displayed rows and pick only selected ones
    for (let i = 0; i < displayedRows; i++) {
      const rowNode = event.api.getDisplayedRowAtIndex(i);
      if (rowNode && rowNode.isSelected()) {
        orderedSelectedTags.push(rowNode.data);
      }
    }
    setSelectedCopyTag(orderedSelectedTags);
    let childElementWhichIsChanged = findWhichElementIsNotExists(defaultChildSelected, orderedSelectedTags);
    // let findNewSelectedObjArray = findNewSelectedObj (tempSelectedData)
    setChangedChildSelectedData(childElementWhichIsChanged);
    let count1 = 0, count2 = 0;
    orderedSelectedTags.map((item) => {
      if (item.parent_tag_id !== null) {
        count1 = count1 + 1;
      } else {
        count2 = count2 + 1;
      }
    });
    // if (count1 > 0 && count2 > 0) {
    //   toastr.error('Please perform only one operation at a time.');
    //   setErrors(1)
    //   setRemoveIcon('all')
    //   return;
    // } else {
    //   setErrors(0)
    // }
    // if (count1 > 0) {
    //   setRemoveIcon(true);
    // } else {
    //   setRemoveIcon(false);
    // }

    if (orderedSelectedTags.length === 0) {
      // toastr.error("Please select one Tag")
      setErrors(1)
      setRemoveIcon('all')
    } else if (orderedSelectedTags.length > 20 + alreadyCount) {
      // toastr.error(t('You can select maximum 20 tags.'))
      setRemoveIcon('all')
      setErrors(1)

    }
  }
  const validateSelectedCopyData = (data) => {
    if (data && data.length > 0) {
      let validate = true;
      //validate pa ref id override
      // data.map((item)=>{
      //   if (item.pur_pa_id){
      //     validate = false;
      //   }
      // });

      if (validate) {
        //call copy api
        handleCopyTags()
      } else {

        setShowCopyErrorPopup(true);
        //show pa ref id error message
      }
    }
  }

  // wildcardsearch
  const filterArray = (array, expression) => {
    var regex = convertWildcardStringToRegExp(expression);
    //console.log('RegExp: ' + regex);
    return array.filter(function (item) {
      return regex.test(item.tag_number) || regex.test(item.gen_technology_type) || regex.test(item.gen_instrument_type)
        || regex.test(item.gen_base_model_1) || regex.test(item.gen_base_model_2) || regex.test(item.gen_base_model_3)
        || regex.test(item.gen_base_model_4) || regex.test(item.gen_base_model_5) || regex.test(item.gen_base_model_6)
        || regex.test(item.pur_buyout_part_code1) || regex.test(item.pur_buyout_part_code2) ||
        regex.test(item.pur_mod_num_part1) || regex.test(item.pur_mod_num_part2) || regex.test(item.pur_mod_num_part3)
        || regex.test(item.config_status) || regex.test(item.pur_pa_id)
    });
  }

  // });
  //   }


  //  ----------------

  // const [tsActnVal, settsActnVal] = useState(tagStatusNew && tagStatusNew[0]?.actions);
  // const [tsActValTemp, setTsActValTemp] = useState({ value: tagStatusNew[0].value, label: tagStatusNew[0].label });
  // const [tsActValSubTemp, setTsActValSubTemp] = useState({ value: tagStatusNew[0]?.actions[0].value, label: tagStatusNew[0]?.actions[0].label });

  const tagStatusChange = (e) => {
    //  setTsActValTemp({ value: e.value, label: e.label });
    settsValL1label(e.label);
    settsValL1(e.value);
    settsActnVal(e.actions);
  }

  const tsActionChange = (e) => {
    settsValL2(e.value);

    //  setTsActValSubTemp({ value: e.value, label: e.label });
  }
  const noRowSelected = () => {

    // console.log("No row Selected to action")
    toastr.error(t('Please Select the rows inside the Table'));
    setmultiTagDrop(null);
    toggleStatus();
  }
  const rowDataUpdated = useCallback(() => {
    settagDataList([]);
  }, [])



  useEffect(() => {
    setPendingType([]);
    setCurrentType(0);
    if (tsActnVal && tsValL1) {
      if (tsValL2) {
        if (selectedRowsData) {
          if (selectedRowsData.length >= 1) {
            let datachange = false;
            selectedRowsData.map((rowItem) => {
              if (rowItem.tag_line_status !== tsValL2) {
                datachange = true;
              }
            });

            if (datachange) {
              toggleStatus();
              selectedRowsData.map((rowItem) => {
                let rowItem2 = {};
                // let rowItemDY = {};

                if (rowItem.tag_line_status !== tsValL2) {
                  rowItem.tag_line_status = tsValL2;
                  //make objects dynamic start
                  //   for (let [key, value] of Object.entries(rowItem)) {
                  //     if(value){
                  //       rowItemDY[key] = value;
                  //     }   
                  //   }
                  //   rowItemDY.tag_status = tsValL2; 
                  //make objects dynamic end

                  rowItem2.project_id = rowItem.project_id;
                  rowItem2.package_id = rowItem.package_id;
                  rowItem2.technology_id = rowItem.technology_id;
                  rowItem2.revision = rowItem.revision;
                  rowItem2.tag_id = rowItem.tag_id;
                  rowItem2.tag_number = rowItem.tag_number;
                  rowItem2.config_status = rowItem.config_status;
                  // rowItem2.config_status = null;
                  //   rowItem2.last_updatedate = new Date();
                  rowItem2.tag_line_status = tsValL2;
                  //rowItem2.gen_costing_status = "IN-PROCESS";
                  rowItem2.gen_technology_type = rowItem.gen_technology_type;

                  setmultiRowPL((oldRow) => {
                    return [...oldRow, rowItem2]
                  });
                  //settagDataList(null);
                  //rowDataUpdated();
                }
              });

              //    toastr.success(tsValL1label + " Updated Successfully "); 
            } else {
              //if already same then here Function will trigger

              //  console.log(tsValL1label + " already " + tsValL2);
              toastr.success(tsValL1label + " already " + tsValL2);
              setmultiTagDrop(null);
              toggleStatus();
            }
          } else {
            noRowSelected();
          }
        } else if (!selectedRowsData) {
          noRowSelected();
        }
      }
    } else if (tsValL1) {
      //if no action then here Function will trigger
      // console.log(tsValL1label + " have no actions");
      toggleStatus();
      setmultiTagDrop(null);
    }
    if (multiRowPL?.length >= 1 && selectedRowsData?.length >= 1) {
      let pkgDtls = {
        project_id: selectedRowsData[0].project_id,
        package_id: selectedRowsData[0].package_id,
        revision: selectedRowsData[0].revision,
        mode: "UPDATE",
        ttlTagCount: multiRowPL.length
      };
      setpkgDtls2(pkgDtls);

      multiRowPL.map((dt) => {
        if (!getType.includes(dt.gen_technology_type)) {
          getType.push(dt.gen_technology_type);
        }
      });

      let payloadUpdate;
      let tempPayload = [];
      getType.map((mData, i) => {

        let data2 = multiRowPL.filter((v) => v.gen_technology_type === getType[i]);
        payloadUpdate = { recordsArr: data2, pkg: pkgDtls, type: getType[i], status: 'START', from: 'singleClickMultiUpdate', colToUpdate: tsValL1 }

        if ((i + 1) != getType.length) {
          tempPayload.push(payloadUpdate);
        }
      })

      setPendingType(tempPayload);
      dispatch(showLoader(true));
      setTimeout(() => {
        setmultiTagDrop(null);
      }, 100);
      setTimeout(() => {
        if (!tsValL1) {
          dispatch(updateReviStartAct(payloadUpdate));  // Multi payload dispatch 
          setmultiRowPL([]);
        }
      }, 500);
    }
  }, [tsActnVal, tsValL1, tsValL2]);

  useEffect(() => {
    if (pendingType.length > 0 && revisionState.phase === "SUCCESS" && currentType < pendingType.length) {
      dispatch(showLoader(true));
      setTimeout(() => {
        setmultiTagDrop(null);
      }, 100);
      setTimeout(() => {
        dispatch(updateReviStartAct(pendingType[currentType]));  // Multi payload dispatch 
        setmultiRowPL([]);
      }, 500);
      setCurrentType(currentType + 1);

    }
  }, [pendingType, revisionState])

  useEffect(() => {
    if (isTimeOut) {
      let payloadUpdate = { recordsArr: revisionState.timeOutApiPayload, pkg: pkgDtls2, status: 'START', from: 'singleClickMultiUpdate' }
      dispatch(updateReviStartAct(payloadUpdate));  // Failed payload Redispatch
    }
  }, [isTimeOut]);



  //const sortAlphaNumTag = (a, b) => a.tag_number.localeCompare(b.tag_number, 'en', { numeric: true })
  const sortAlphaNumTag = (a, b) => a.tag_number ? a.tag_number.localeCompare(b.tag_number, 'en', { numeric: true }) : 0

  // useEffect(() => {
  //   console.log("tags use effect ran")
  //   if (tags.length > 0) {
  //     // let tagDatafiltered = tags.filter(o => o.selected === 'Y').sort(sortAlphaNumTag);
  //     // console.log(tagDatafiltered);
  //     // settagDataList(tagDatafiltered)
  //     // gridApi?.deselectAll();
  //     // setTimeout(function() { gridApi.redrawRows(); }, 0)
  //     let tagDatafiltered = tags.filter(o => o.selected.toUpperCase() === 'Y').sort(sortAlphaNumTag);

  //     settagDataList(tagDatafiltered);

  //     setTimeout(() => {
  //       //gridApi?.deselectAll();
  //       //gridApi?.redrawRows();

  //     }, 0);


  //   }
  // }, [tags])



  useEffect(() => {
    let tagData = tags
      .filter((tag) =>
        !isInstrumentationTab
          ? tag.gen_technology_type === wsTabValue
          : !commercialTypes.includes(tag.gen_technology_type)
      )
      .filter((o) => o.selected === "Y")
      .sort(sortAlphaNumTag);

    if (props.findTag.length) {
      let tagDatafiltered = filterArray(tagData, props.findTag)
      settagDataList(tagDatafiltered)
    } else {
      settagDataList(tagData)

    }

  }, [props.findTag, tags, wsTabValue])


  const arrowLeft = () => {
    // console.log(pckgCouterBadges.current.scrollWidth - pckgCouterBadges.current.clientWidth)
    pckgCouterBadges.current.scrollLeft = pckgCouterBadges.current.scrollLeft - 200;
    setBadgesHScroll(pckgCouterBadges.current.scrollLeft);
  }

  const arrowRight = () => {
    // console.log(pckgCouterBadges.current.scrollWidth - pckgCouterBadges.current.clientWidth)
    pckgCouterBadges.current.scrollLeft = pckgCouterBadges.current.scrollLeft + 200;
    setBadgesHScroll(pckgCouterBadges.current.scrollLeft);
  }


  const pckgBadgesScroll = (e) => {

    let scrollPercentage = Math.round(100 * e.target.scrollLeft / (e.target.scrollWidth - e.target.clientWidth));
    setBadgesHScroll(scrollPercentage)

  }

  const backspaceLongLeftPress = useLongPress(arrowLeft, 500);
  const backspaceLongRightPress = useLongPress(arrowRight, 500);

  useEffect(() => {
    if (showProgressBar) {
      setdataLoaded(false);


      setTimeout(() => {
        gridApi?.showLoadingOverlay()
      }, 0);

    } else if (!showProgressBar) {
      setdataLoaded(true);
      setTimeout(() => {
        gridApi?.hideOverlay()
      }, 0);
    }
  }, [showProgressBar])




  const handleClickDROPMulti = (event) => {
    setmultiTagDrop(event.currentTarget);
  };

  const handleClose = () => {
    setmultiTagDrop(null);
    settsActnVal(null);
  };
  const copySizingOpen = () => {
    setCopySizingPopup(true);
  }
  const copySizingClose = () => {
    setCopySizingPopup(false);
    setSelectedCopyOption("");
    setRemoveIcon('all');
    setSelectedRowsDataCopy([])
  }
  // const copyConfigurationOpen = () => {
  //   setCopyConfigurationPopup(true);
  // }
  // const copyConfigurationClose = () => {
  //   setCopyConfigurationPopup(false);
  // }

  const handleCopyValidate = () => {
    // setData(selDataset)
    if (selectedRowsData === undefined) {
      toastr.error(t('Please select one Tag'));
      return;
    } else if (!(selectedRowsData.length === 1)) {
      toastr.error(t('Please select one Tag'));
      return;
    }


    let validate = true;
    if (selectedRowsData) {
      let tempSelectedData = selectedRowsData[0];
      // if (tempSelectedData.pur_pa_id !== null && tempSelectedData.config_status && (tempSelectedData.config_status).toLowerCase().includes('config')) {
      if (tempSelectedData.config_status && ((tempSelectedData.config_status).toLowerCase().startsWith('valid') || (tempSelectedData.config_status).toLowerCase().startsWith('invalid') || (tempSelectedData.config_status).toLowerCase().startsWith('inval-price'))) {
        copySizingOpen();
        //remove parent selected data 
        let tempFilterData = [];
        let defSleChild = [];
        // commonParentTagData.map((item) => {
        //   if ((item.tag_id !== tempSelectedData.tag_id) && (!item.config_status.startsWith('VALID')) && (item.gen_prod_desc === tempSelectedData.gen_prod_desc) && (item.gen_technology_type === tempSelectedData.gen_technology_type) && (item.gen_instrument_type === tempSelectedData.gen_instrument_type) && ((item.parent_tag_id === null || item.parent_tag_id === tempSelectedData.tag_id))) {
        //     if (item.parent_tag_id == tempSelectedData.tag_id) {
        //       let obj = item;
        //       obj.parentChild = true;
        //       // tempFilterData.unshift(obj);
        //       defSleChild.push(obj);
        //     } else {
        //       tempFilterData.push(item);
        //     }

        //   }
        // else if (item.tag_id === tempSelectedData.tag_id){
        //   let obj =item;
        //   obj.parentTag = true;
        //   tempFilterData.push(obj)
        // }
        // })
        // defSleChild.sort(sortBaseOnAlphaNum)
        // setDefaultChildSelected(defSleChild);
        //     tempFilterData =tagDataList.filter((item)=> item.tag_id !==tempSelectedData.tag_id && (item.gen_prod_desc === tempSelectedData.gen_prod_desc) && (item.gen_technology_type === tempSelectedData.gen_technology_type)&& (item.gen_instrument_type === tempSelectedData.gen_instrument_type))
        // let tempFinalSortedChildData = defSleChild.concat(tempFilterData);
        // let tempFinalSortedChildData = tagDataList.filter((item) => item.tag_id !== tempSelectedData.tag_id  && (item.gen_prod_desc === tempSelectedData.gen_prod_desc) && (item.gen_technology_type === tempSelectedData.gen_technology_type) && (item.gen_instrument_type === tempSelectedData.gen_instrument_type))
        // setFilterTagData(tempFinalSortedChildData)
        const pl = {
          package_id: ctrl.pkg.package_id,
          category: tempSelectedData.gen_technology_type,
          selectedRow: tempSelectedData
        }
        dispatch(switchDatasetChild(pl))
      } else {
        setSelectedCopyOption("")
        setCopyPopup(false);
        toastr.error(t('Please select a Tag with VALID/ INVALID/ INVAL-PRICE Configuration Status'))
      }
    }
  }
  const continueRemoveAssociation = () => {
    setRemoveChildAssociation(false)
    handleRemoveChildTag(true)
  }

  const handleOpenDuplicatelinePopup = () => {
    setDuplicateLinePopup(true);
  }
  const handleDuplicateLinePopupClose = () => {
    setDuplicateLinePopup(false);
  }
  const handleDuplicateTagLineValidate = () => {
    let errors = {}
    if (!duplicateTagName) {
      errors.duplicateTagName = "**Tag Name is required";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      let obj = selectedRowsData && selectedRowsData.length > 0 && selectedRowsData[0];
      if (obj) {
        obj.duplicate_tag_name = duplicateTagName;
        obj.selected_options = duplicateLineSelectedChk;
        dispatch(showLoader(true));
        dispatch(createDuplicateLine(obj));
        setDuplicateLinePopup(false);
        setDuplicateLineSelectedChk([]);
        setSelectedCopyOption("");
      }
    }
  }
  const handleSelectedDuplicateChks = (e) => {
    let isValueChecked = e.target.checked;
    let value = e.target.value;
    if (isValueChecked) {
      let tempselected = [...duplicateLineSelectedChk];
      tempselected.push(value);
      setDuplicateLineSelectedChk(tempselected);
    } else {
      let tempSelected = [...duplicateLineSelectedChk];
      let ind = tempSelected.indexOf(value);
      tempSelected.splice(ind, 1);
      setDuplicateLineSelectedChk(tempSelected);
    }
  }
  // const handleCopyConfigValidate = () => {
  //   if (!(selectedRowsDataCopyConf)) {
  //     toastr.error('Please Select Records');

  //   } else if (selectedRowsDataCopyConf && (selectedRowsDataCopyConf.length === 0)) {
  //     toastr.error("Please select atleast one record");
  //   } else if (selectedRowsDataCopyConf.length <= 20) {
  //     toastr.success("Record Validated")
  //   } else {
  //     toastr.error("Please select maximum 20 records")
  //   }
  // }
  const handleCopySizing = () => {
    let temp = [];
    selectedRowsDataCopy && selectedRowsDataCopy.map((item) => {
      // if (!item.parent_tag_id) {
      temp.push(item);
      // }
    });
    if (temp === undefined || temp?.length === 0) {
      toastr.error(t('Please select one Tag'));
    }
    // else if (temp.length > 20) {
    //   toastr.error(t('You can select maximum 20 tags'))

    // }
    else {
      validateSelectedCopyData(selectedRowsDataCopy)
    }
  }

  const handleRemoveChildTag = (modal = false) => {
    let temp = selectedCopyTag;
    if (modal) {
      temp = selectedRowsData
    } else {
      temp = selectedCopyTag
    }
    let selectedRow = modal ? selectedRowsData : selectedCopyTag
    let technology_name = selectedRow && selectedRow[0] && selectedRow[0].gen_technology_type
    let parent_tag_id = selectedRow && selectedRow[0] && selectedRow[0].parent_tag_id
    let bodyData = [];
    temp.map((item) => {
      if (item.parent_tag_id !== null) {
        let obj = {}
        obj.project_id = item.project_id;
        obj.package_id = item.package_id;
        obj.tag_id = item.tag_id;
        obj.parent_tag_id = item.parent_tag_id;
        bodyData.push(obj);
      }
    })
    let body = {
      technology_name: technology_name,
      tags: bodyData
    }
    dispatch(removeChildTag(body));
    copySizingClose();
  }
  const handleCopyTags = () => {
    let bodyData = [];

    const displayedRows = childGridApi.getDisplayedRowCount();

    setSelectedCopyTag(displayedRows);
    const orderedSelectedTags = [];

    for (let i = 0; i < displayedRows; i++) {
      const rowNode = childGridApi.getDisplayedRowAtIndex(i);
      if (rowNode && rowNode.isSelected()) {
        orderedSelectedTags.push(rowNode.data);
      }
    }

    const limitedTags = orderedSelectedTags.slice(0, 20);

    limitedTags.map((item) => {
      if (!item.parentChild === true) {
        let obj = {
          project_id: item.project_id,
          package_id: item.package_id,
          tag_id: item.tag_id,
        };
        bodyData.push(obj);
      }
    });


    if (selectedRowsData.length > 0) {
      let body = {
        tags: bodyData,
        technology_name: selectedRowsData[0].technology_name,
        project_id: selectedRowsData[0].project_id,
        package_id: selectedRowsData[0].package_id,
        tag_id: selectedRowsData[0].tag_id,
        pa_ref_id: selectedRowsData[0].pur_pa_id,
      };

      dispatch(showLoader(true));
      dispatch(createCopyTag(body));
      setConfirmationPopup(false);
      copySizingClose();
    }
  };



  // const handleChangeCopyOption = (e) => {
  //   setSelectedCopyOption(e.target.value);
  // }

  const open = Boolean(multiTagDrop);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    if (fetchedDataCnt === gettagcntTl) {
      //dispatch(bulkTagConfigStatusStart({ "project_id": ctrl.data.project_id, "package_id": ctrl.pkg.package_id }))
      dispatch(hideProgressBar());
      setTimeout(() => {
        // gridApi?.deselectAll();
        // gridApi?.redrawRows();
        // gridApi?.hideOverlay()
      }, 0);
    }
    else {
      setTimeout(() => {
        gridApi?.showLoadingOverlay()
      }, 0);
    }
  }, [fetchedDataCnt])

  useEffect(() => {
    if (eprojs.phase === 'LOADING' && eprojs.tagStatusRF) {
      dispatch(showLoader(true));
      setStatusUpdateStart(true);
    }
    if (eprojs.phase === 'SUCCESS' && statusUpdateStart) {
      setStatusUpdate(false);
      setTimeout(() => {
        setStatusUpdate(true);
        dispatch(showLoader(false));
      }, 10)

      setStatusUpdateStart(false);
    }
  }, [eprojs.phase])

  useEffect(() => {
    if (!openCmtConfirm) return;

    const dialogContent = commentDialogContentRef.current;
    if (!dialogContent) return;

    requestAnimationFrame(() => {
      dialogContent.scrollTop = commentScrollTopRef.current;
    });
  }, [openCmtConfirm, selectedPkgCmnts]);

  // useEffect(() => {
  //   if (childGridRef.current) {
  //     const api = childGridRef.current.api;
  //     const topRecord = filterTagData.find((record) => record?.parentChild === true);
  //     if (topRecord) {
  //       const node = api.getRowNode(topRecord.id)
  //       if (node) {
  //         node.setRowTop(0); // Move the row to the top
  //         api.refreshCells({ force: true }); //Refresh the grid to apply changes
  //       }
  //     }
  //   }
  // }, [filterTagData])
  const sortAlphaNum = (a, b) => (a.tag_number).localeCompare(b.tag_number, 'en', { numeric: true })
  const sortBaseOnAlphaNum = (a, b) => {
    const aValue = a.tag_number;
    const bValue = b.tag_number;

    //Extract the alphanumeric portion of the string
    const aAlphaNumeric = aValue.match(/[a-zA-Z]+|[0-9]+/g)
    const bAlphaNumeric = bValue.match(/[a-zA-Z]+|[0-9]+/g)

    //compare the alphanumberic portion
    for (let i = 0; i < Math.max(aAlphaNumeric?.length, bAlphaNumeric?.length); i++) {
      if (!aAlphaNumeric[i]) return -1;
      if (!bAlphaNumeric[i]) return 1;

      const aChunk = aAlphaNumeric[i];
      const bChunk = bAlphaNumeric[i];

      if (isNaN(aChunk) && isNaN(bChunk)) {
        //Both chunks are non-numberic,perform lexicographic comparison
        const result = aChunk.localeCompare(bChunk);
        if (result !== 0) return result;
      } else {
        //At least one chunk is numeric,convert and compare as a numbers
        const aNum = parseInt(aChunk, 10);
        const bNum = parseInt(bChunk, 10);
        if (aNum < bNum) return -1;
        if (aNum < bNum) return 1;
      }
    }

    //If all chunks are equal, compare the original strings
    return aValue.localeCompare(bValue);
  }
  // useEffect(() => {
  //   setParentTableData(commonParentTagData);
  // tagDataList.sort((a, b) => (a.tag_number < b.tag_number) ? 1 : ((b.tag_number < a.tag_number) ? -1 : 0));
  // let tempSort = [];
  // tagDataList.map((item) => {
  //   if (item.parent_tag_id === null) {
  //     let obj = item;
  //     obj.children = [];
  //     tempSort.push(obj);
  //   } else if (item.tag_id === item.parent_tag_id) {
  //     let obj = item;
  //     obj.children = [];
  //     tempSort.unshift(obj);

  //   } else {
  //     let obj = item;
  //     obj.children = [];
  //     tempSort.push(obj);
  //   }
  // });
  // let finalArr = [];
  // tempSort.map((item) => {
  //   if (item.tag_id === item.parent_tag_id) {
  //     finalArr.push(item)
  //   } else if (item.parent_tag_id !== null) {
  //     let getIndex = finalArr.findIndex((innerItem) => innerItem.tag_id === item.parent_tag_id);
  //     if (finalArr[getIndex]) finalArr[getIndex].children.push(item);
  //     else finalArr.push(item);
  //   } else {
  //     finalArr.push(item);
  //   }
  // })
  // let finalArrayFormat = [];
  // let nullData = [];
  // //parent sort
  // let allParents = [];
  // let allNonAsign = []
  // finalArr.map((item) => {
  //   if (item.children.length > 0) {
  //     allParents.push(item);
  //   } else {
  //     allNonAsign.push(item)
  //   }
  // })
  // allParents.sort(sortBaseOnAlphaNum);
  // allNonAsign.sort(sortBaseOnAlphaNum)
  // finalArr = allParents.concat(allNonAsign);
  // finalArr.map((item) => {
  //   if (item.children) {
  //     let tempItem = item;
  //     let children = tempItem.children;
  //     delete tempItem.children;
  //     if (!(children.length === 0)) {
  //       finalArrayFormat.push(tempItem);
  //     }
  //     if (children.length === 0) {
  //       nullData.push(item);
  //     }
  //     children && children.length > 0 && children.sort(sortBaseOnAlphaNum);
  //     children && children.length > 0 && children.map((childItem) => {
  //       finalArrayFormat.push(childItem)
  //     });
  //   }
  // })
  // nullData.sort(sortBaseOnAlphaNum)
  // let res = finalArrayFormat.concat(nullData);
  // setParentTableData(res);
  //   if (commonParentTagData === null || commonParentTagData?.length === 0 || phase === 'SUCCESS') {
  //     setCommonParentTagData(tagDataList);
  //     setParentTableData(tagDataList)
  //   }
  // }, [tagDataList]);
  // useEffect(() => {
  //   if (props.findTag.length) {
  //     let res = filterArray(tagDataList, props.findTag);
  //     handleCustomSortParentTableData(res);
  //   } else {
  //     // handleCustomSortParentTableData(tagDataList)
  //   }
  // }, [props.findTag, tagDataList])

  const handleCustomSortParentTableData = (tempArray) => {
    setParentTableData(tempArray);
    //   tempArray.sort((a, b) => (a.tag_number < b.tag_number) ? 1 : ((b.tag_number < a.tag_number) ? -1 : 0));
    //   let tempSort = [];
    //   tempArray.map((item) => {
    //     if (item.parent_tag_id === null) {
    //       let obj = item;
    //       obj.children = [];
    //       tempSort.push(obj)
    //     } else if (item.tag_id === item.parent_tag_id) {
    //       let obj = item;
    //       obj.children = [];
    //       tempSort.unshift(obj)
    //     } else {
    //       let obj = item;
    //       obj.children = [];
    //       tempSort.push(obj)
    //     }
    //   });
    //   let finalArr = [];
    //   tempSort.map((item) => {
    //     if (item.tag_id === item.parent_tag_id) {
    //       finalArr.push(item)
    //     } else if (item.parent_tag_id !== null) {
    //       let getIndex = finalArr.findIndex((innerItem) => innerItem.tag_id === item.parent_tag_id);
    //       if (finalArr[getIndex]) finalArr[getIndex].children.push(item);
    //       else finalArr.push(item);
    //     } else {
    //       finalArr.push(item);
    //     }
    //   })
    //   let finalArrayFormat = [];
    //   let nullData = [];
    //   //parent sort
    //   let allParents = [];
    //   let allNonAsign = []
    //   finalArr.map((item) => {
    //     if (item.children.length > 0) {
    //       allParents.push(item);
    //     } else {
    //       allNonAsign.push(item)
    //     }
    //   })
    //   allParents.sort(sortBaseOnAlphaNum);
    //   allNonAsign.sort(sortBaseOnAlphaNum)
    //   finalArr = allParents.concat(allNonAsign);
    //   finalArr.map((item) => {
    //     if (item.children) {
    //       let tempItem = item;
    //       let children = tempItem.children;
    //       delete tempItem.children;
    //       if (!(children.length === 0)) {
    //         finalArrayFormat.push(tempItem);
    //       }
    //       if (children.length === 0) {
    //         nullData.push(item);
    //       }
    //       children && children.length > 0 && children.sort(sortBaseOnAlphaNum);
    //       children && children.length > 0 && children.map((childItem) => {
    //         finalArrayFormat.push(childItem)
    //       });
    //     }
    //   })
    //   nullData.sort(sortBaseOnAlphaNum)
    //   let res = finalArrayFormat.concat(nullData);
    //   setParentTableData(res);
    // }
    // const getRowStyleParent = (params) => {
    //   if (params.data.tag_id !== params.data.parent_tag_id && params.data.parent_tag_id !== null) {
    //     // copy table ----> Already child background color
    //     return { 'background-color': '	#59c8ab' }
    //   }
    //   else {
    //     return null;
    //     ;
    //   }
  };
  const getRowStyleParentTable = (params) => {
    if (params.data.tag_id === params.data.parent_tag_id) {
      // parent table ----> Parent tagdata background color
      return { 'background-color': '#dbf7d1' }
    }
    else {
      return null;
    }
  }
  useEffect(() => {
    if (phase === "UPDATED") {
      gridApi && gridApi.setRowData(tagDataList)
      handleCustomSortParentTableData(tagDataList)
      dispatch(showLoader(false))
    }
    // show loader when phase is loading
    // if (phase === "LOADING") {
    //   dispatch(showLoader(true))
    // }
  }, [phase])

  const reportClick = () => {
    setClicked((prevState) => !prevState);
    handleCloseReport();
  }

  const viewReportStatusClick = () => {
    setOpenReportStatus(true);
    handleCloseReport();
  }
  const batchReportStatusClick = () => {
    setOpenBatchReportStatus(true);
    handleCloseReport();
  }
  const selectReportTypeClick = () => {
    if (!selectedRowsData || selectedRowsData.length === 0) {
      toastr.error(t('Please Select the Tag Line.'));
      return;
    }

    setOpenSelectReportType(true);
    handleCloseReport();
  }
  const clickFromStatus = () => {
    setOpenReportStatus(false);
  }

  const clickFromDeletedTag = () => {
    setRestoreActive(false);
  }
  const deleteClick = () => {
    setDelClicked(prevState => !prevState);
    setmultiRowPL([]);
    settsValL1(null);
    setOpenMenu(false);
    setClickFM('Delete');
    setRestoreActive(false);
  }

  const restoreClick = () => {
    setDelClicked(prevState => !prevState);
    setmultiRowPL([]);
    settsValL1(null);
    setOpenMenu(false);
    setClickFM('Restore');

  }

  const getResdelClick = (req, pl, colName) => {
    if (req === "DeleteTags") {
      pl.map((plTags) => {
        tagDataList.map((tagData) => {
          if (tagData.tag_id === plTags.tag_id) {
            tagData[colName] = plTags[colName];
          }
        })
      })

      setmultiRowPL(pl);
      settsValL1(colName);
      setTimeout(function () { gridApi?.refreshCells(); }, 0)

    }
  }
  const openMenuFN = () => {
    setOpenMenu(!openMenu);
  }

  const getDeletedTags = () => {
    setOpenMenu(false);
    eprojs.deletedTags = [];
    let deletedTAGPL = {
      pid: ctrl.pkg.project_id,
      pkgid: ctrl.pkg.package_id,
      rev: ctrl.pkg.active_revision,
      enable: "N",
      type: "GET_DELETED_TAGS"
    }
    dispatch(fetchTagCountAct(deletedTAGPL));
    setRestoreActive(true);
    setClickFM('Restore');
    // setTagsLoaded(false)
  }



  const removeDeletedTags = () => {
    setOpenMenu(false);
    if (tagDataList) {
      tagDataList.map((tag) => {
        if (tag.tag_enabled === "N") {
          setDeleteTag((oldID) => {
            return [...oldID, tag.tag_id];
          });
        }
      })
    }
  }

  useEffect(() => {
    if (deleteTag.length > 0) {
      dispatch(showLoader(true));
      dispatch(deleteTags(deleteTag));
      setTimeout(() => {
        dispatch(showLoader(false));
        setRestoreActive(false);
      }, 2000)
    }
  }, [deleteTag])


  useEffect(() => {
    if (restoreActive) {
      let tempTL = 0;
      for (let value of Object.values(gettagcnt)) {
        tempTL += value;
      }
      if (tempTL == 0) {
        setRestoreActive(false);
        setSelectedRowsData([]);
        toastr.info(t('No Deleted Tags Found'));
      }
    }
  }, [gettagcnt])

  useEffect(() => {

    if (restoreActive && !ctrl.loading) {
      let haveDeletedData = false;
      if (tags.length > 0) {
        tags.map((tag) => {
          if (tag.tag_enabled === "N") {
            haveDeletedData = true;
          }
        })
        if (!haveDeletedData) {
          setRestoreActive(false);
        } else {
          setRestoreActive(true);
        }
      }
    }
  }, [tags])

  // const configClick = () =>{
  //   setClickedCon(!clickedCon); 
  // }

  const handleClickReport = (event) => {
    setReport(event.currentTarget);
  };

  const handleCloseReport = () => {
    setReport(null);
  };
  const handleClickDelete = (event) => {
    setDelete(event.currentTarget);
  };

  const handleCloseDelete = () => {
    setDelete(null);
  };
  const handleClickFilter = (event) => {
    setFilter(event.currentTarget);
  };
  const handleCloseFilter = () => {
    setFilter(null);
  };

  // --pricing btn ----
  const handleClickPricing = (event) => {
    setPricing(event.currentTarget);
  };

  const handleClosePricing = () => {
    setPricing(null);
  };
  // --pricing btn ----
  const openFilter = Boolean(anchorFilter);
  const idFilter = openFilter ? 'simple-popover' : undefined;

  const openReport = Boolean(anchorReport);
  const idReport = openReport ? 'simple-popover' : undefined;

  const openDelete = Boolean(anchorDelete);
  const idDelete = openDelete ? 'simple-popover' : undefined;
  const selectedDeletedData = (deletedRows) => {
    setSelectedRowsData(deletedRows);
  }
  const destroyFn = () => {
    setDestroy(true);
    setTimeout(() => {
      setDestroy(false);
    })
  }

  //pricing btn start

  const openPricing = Boolean(anchorPricing);
  const idPricing = openPricing ? 'simple-popover' : undefined;


  // confg bulk tag --start--



  const bulkConfigTagValidHandler = () => {
    gridApi?.stopEditing()
    let selectedNodes = gridApi.getSelectedNodes();
    const selectedRows = gridApi?.getSelectedRows();

    // const base_model_flag = selectedRows.some(ele => (ele.gen_base_model_1 == "" || ele.gen_base_model_1 == null))
    // const assembly_model_flag = selectedRows.some(ele => (ele.ord_it_assembly_model == "" || ele.ord_it_assembly_model == null))
    // const model_number_flag = selectedRows.some(ele => (ele.pur_mod_num_part1 == "" || ele.pur_mod_num_part1 == null))
    let errMsg = "";
    const invalidConfigTags = selectedRows.filter(ele => {
      if (
        ((ele.gen_base_model_1 == "" || ele.gen_base_model_1 == null) && (ele.ord_it_assembly_model == "" || ele.ord_it_assembly_model == null)) ||
        (ele.pur_mod_num_part1 == "" || ele.pur_mod_num_part1 == null)
      ) {
        errMsg = "Only Tags, with Base Model 1 / Assembly Model and Model Number 1 can be Bulk configured."
        return ele;
      }
      // else if ((ele.gen_base_model_1 != "" || ele.gen_base_model_1 != null) && (ele.ord_it_assembly_model == "" || ele.ord_it_assembly_model == null)) {

      //   if ((ele.gen_base_model_2 != "" || ele.gen_base_model_2 != null) || (ele.pur_mod_num_part2 != "" || ele.pur_mod_num_part2 != null) ||
      //     (ele.gen_base_model_3 != "" || ele.gen_base_model_3 != null) || (ele.pur_mod_num_part3 != "" || ele.pur_mod_num_part3 != null) ||
      //     (ele.gen_base_model_4 != "" || ele.gen_base_model_4 != null) || (ele.pur_mod_num_part4 != "" || ele.pur_mod_num_part4 != null) ||
      //     (ele.gen_base_model_5 != "" || ele.gen_base_model_5 != null) || (ele.pur_mod_num_part5 != "" || ele.pur_mod_num_part5 != null)) {
      //     errMsg = "Tags Having Miltiple Base Model/Model Number 2/3/4/5 without Assembly Model cannot be configured in bulk";
      //     return ele;
      //   }
      // }
      // ||
      // (
      //   !ele.config_status?.includes("COPIED-VALID") &&
      //   !ele.config_status?.includes("COPIED-INVALID")
      //   &&
      //   (ele.config_status?.includes("VALID") || ele.config_status?.includes("INVALID") || ele.config_status?.includes("CANCELED"))
      // )
    }
    );



    let isValid = true;

    if (selectedRows.length === 0) {
      toastr.error('Please select the tag line')
      isValid = false;
    }
    // else if (selectedRows.length > 150) {
    //   toastr.error(t(`Maximum 150 tags can be configured at a time. (Selected Tags count: ${selectedRows.length})`));
    //   isValid = false;
    // } 
    else if (invalidConfigTags.length === selectedRows.length) {
      toastr.error(`${errMsg}`);
      isValid = false;
    } else if (invalidConfigTags.length > 0) {
      selectedNodes.forEach(node => {
        if (invalidConfigTags.some(tag => tag.tag_id === node.data.tag_id)) {
          // deselection of rows from grid
          node.setSelected(false);
          isValid = true;
        }
      });
    }
    // logic for selected tags count in bulk configuration modal.
    setSelectedConfigRowsData(selectedRows.length - invalidConfigTags.length);
    // else if (selectedRows.length === 1) {
    //   toastr.error('Please select multiple tag line')
    //   isValid = false;
    // }
    // else {

    //   const deselectedRows = [];
    //   gridRef.current.api.forEachNode((node) => {

    //     if ((node.data.gen_base_model_1 == "" || node.data.gen_base_model_1 == null) && (node.data.ord_it_assembly_model == "" || node.data.ord_it_assembly_model == null)) {
    //       console.log(node)
    //       toastr.error(`${node.data.tag_number}: Invalid Tag for Configuration, Base Model 1 / Assembly Model Is Missing`);
    //       isValid = false;
    //       node.setSelected(false);
    //     }
    //     if ((node.data.pur_mod_num_part1 == "" || node.data.pur_mod_num_part1 == null)) {
    //       console.log(node)
    //       toastr.error(`${node.data.tag_number}: Invalid Tag for Configuration, Model Number 1 Is Missing`);
    //       isValid = false;
    //       node.setSelected(false);
    //     }
    //     if (node.data.config_status?.includes("VALID") || node.data.config_status?.includes("INVALID") || node.data.config_status?.includes("CANCELLED")) {
    //       console.log(node)
    //       isValid = false;
    //       toastr.error(`${node.data.tag_number}: Tag Status is ${node.data.config_status.split("-")[0]}, It will be ignored for configuration`);
    //       node.setSelected(false);
    //     }
    //   });
    //   // gridRef.current.api.setNodesSelected({
    //   //   nodes: deselectedRows,
    //   //   newValue: false,
    //   // });
    // }
    return isValid
  }

  const bulkConfigPayloadObj2 = (isAsmbly, isRAModel, ele, tagsCount) => {
    let pricing_date = getDtfrmt(ctrl.pkg.pricing_date)

    const priceListArr = ctrl.pkg.price_list?.split('/')
    const priceList = priceListArr?.find(item => item.includes(ele.division_code)) || null;
    // const org_id = techTyps.filter(val => val.description === ele.gen_prod_desc).map(item => item.orgId)[0];
    const org_id = getOrgIdFromDivisionCode(ele.division_code);

    return {
      "Model": "",
      "ModelString": !isAsmbly ? isRAModel ? "" : ele.pur_mod_num_part1 : "",
      "ModelDetail": [
        {
          "ModelString": (isAsmbly || isRAModel) ? (ele.pur_mod_num_part1 == null) ? "" : ele.pur_mod_num_part1 : "",
          "ModelName": ""
        },
        {
          "ModelString": (isAsmbly || isRAModel) ? (ele.pur_mod_num_part2 == null) ? "" : ele.pur_mod_num_part2 : "",
          "ModelName": ""
        },
        {
          "ModelString": (isAsmbly || isRAModel) ? (ele.pur_mod_num_part3 == null) ? "" : ele.pur_mod_num_part3 : "",
          "ModelName": ""
        },
        {
          "ModelString": (isAsmbly || isRAModel) ? (ele.pur_mod_num_part4 == null) ? "" : ele.pur_mod_num_part4 : "",
          "ModelName": ""
        },
        {
          "ModelString": (isAsmbly || isRAModel) ? (ele.pur_mod_num_part5 == null) ? "" : ele.pur_mod_num_part5 : "",
          "ModelName": ""
        },
        {
          "ModelString": (isAsmbly || isRAModel) ? (ele.pur_mod_num_part6 == null) ? "" : ele.pur_mod_num_part6 : "",
          "ModelName": ""
        },

      ],
      "Quantity": (ele.quantity == "" || ele.quantity == null) ? "1" : ele.quantity + "",
      "CurrencyCode": ctrl.pkg.currency || "",
      "PricingRegion": ctrl.pkg.pricing_region || "",
      "Division": ele.division_code || "",
      "CustomerName": ctrl.pkg?.customer_details_json.CustomerName.trim() || "",
      "MailID": profileState.email || "",
      "ProjectName": ctrl.data.project_name,
      "PackageID": ctrl.pkg.package_number + "",
      "TechnologyID": ele.technology_id + "",
      "TagID": `${ele.tag_id}-${ele.tag_number}`,
      //"ConfigHeaderID": ele.pur_configurator_id,
      "ConfigHeaderID": "",
      //"ConfigRevNumber": ele.pur_config_rev_num,
      "ConfigRevNumber": "",
      "ActionIdentifier": "",
      "PriceDate": pricing_date || "",
      "PriceList": priceList || "",
      //"QuoteHeaderId": ele.quote_hdr_id ? ele.quote_hdr_id : "",//
      //"QuoteLineId": ele.quote_line_id ? ele.quote_line_id : "",//
      "QuoteHeaderId": "",
      "QuoteLineId": "",
      "SizeReferenceId": ele.pur_pa_id ? ele.pur_pa_id : "",
      "Source": "PRJWSC",
      "EndDestination": ele.end_dest || "",
      "HostHeaderId": ctrl.pkg.package_id + "" || "",// not menatory
      "TransactionType": 'QUOTE' + '-' + 'DRAFT',
      "QuoteName": "PRJWS",
      "PartNumber": isAsmbly ? ele.ord_it_assembly_model : (isRAModel ? "" : ele.gen_base_model_1),
      "OrgId": org_id + "",
      "PartyId": ctrl.pkg.contact_party_id + "" || "",
      "CustomerAccountId": ctrl.pkg.customer_account_id + "" || "",
      "InvoiceToPartyId": ctrl.pkg.invoice_to_party_id + "" || "",
      "ShipToPatyId": ctrl.pkg.ship_to_paty_id + "" || ""
    }
  }




  const bulkConfigTagPayload = (selectedRows) => {

    let payloadBulkConfig = []
    let selectedTagsList = []
    let tagsCount = selectedRows.length;
    selectedRows.forEach(element => {
      const isAssemblyModel = !(element.ord_it_assembly_model == "" || element.ord_it_assembly_model == null);
      const isRAModel = (element.pur_mod_num_part1 && element.pur_mod_num_part2) ? true : false;
      payloadBulkConfig.push(bulkConfigPayloadObj2(isAssemblyModel, isRAModel, element, tagsCount))
      let tagObj = {
        "batch_id": null,
        "request_by": profileState.email,
        "status": "submitted",
        "package_name": ctrl.pkg.package_name,
        "tag_id": element.tag_id,
        "technology_id": element.technology_id,
        "revision": element.revision,
        "package_id": ctrl.pkg.package_id,
        "project_name": ctrl.data.project_name,
        "failure_reason": null,
        "tag_number": element.tag_number,
        "technology_name": element.technology_name,
        "project_id": ctrl.data.project_id,
        "package_number": ctrl.pkg.package_number,
        "division_code": element.division_code,
        "init_model_detail": (isAssemblyModel || isRAModel) ? JSON.stringify([
          {
            "ModelString": (isAssemblyModel || isRAModel) ? (element.pur_mod_num_part1 == null) ? "" : element.pur_mod_num_part1 : "",
            "indx": 1,
            "assembly_model": element.ord_it_assembly_model
          },
          {
            "ModelString": (isAssemblyModel || isRAModel) ? (element.pur_mod_num_part2 == null) ? "" : element.pur_mod_num_part2 : "",
            "indx": 2
          },
          {
            "ModelString": (isAssemblyModel || isRAModel) ? (element.pur_mod_num_part3 == null) ? "" : element.pur_mod_num_part3 : "",
            "indx": 3
          },
          {
            "ModelString": (isAssemblyModel || isRAModel) ? (element.pur_mod_num_part4 == null) ? "" : element.pur_mod_num_part4 : "",
            "indx": 4
          },
          {
            "ModelString": (isAssemblyModel || isRAModel) ? (element.pur_mod_num_part5 == null) ? "" : element.pur_mod_num_part5 : "",
            "indx": 5
          },
          {
            "ModelString": (isAssemblyModel || isRAModel) ? (element.pur_mod_num_part6 == null) ? "" : element.pur_mod_num_part6 : "",
            "indx": 6
          },

        ]) : JSON.stringify({
          "ModelString": element.pur_mod_num_part1,
          "PartNumber": element.gen_base_model_1 || "",
        })
      }
      selectedTagsList.push(tagObj)
    });
    let payload = {
      "modelconfig": {
        "ModelConfig": {
          "MessageHeader": {
            "MessageID": "",
            "Sender": {
              "ID": "WSCP",
              "Description": "",
              "Application": {
                "ID": ""
              },
              "ApplicationVersion": "",
              "TransactionCode": "",
              "IPAddress": "",
              "SenderMessageID": "",
              "CallingServiceName": "",
              "ContactName": "",
              "ContactEmail": "",
              "ContactPhoneNumber": ""
            },
            "Target": {
              "ID": "OGSI",
              "OverrideRoutingIndicator": "",
              "ServiceName": "",
              "ApplicationTypeCode": "",
              "EndPointURI": ""
            },
            "BusinessGroup": "DPIS",
            "MessageName": "",
            "BusinessObjectName": "",
            "CreationDateTime": "",
            "RequestMessageID": "",
            "MessageProcessingInstruction": {
              "EnvironmentCode": "",
              "DefinitionID": "",
              "InstanceID": "",
              "Priority": "",
              "CompressedFlag": "",
              "CompressedMessage": ""
            },
            "FaultNotification": {
              "BusinessComponentID": "",
              "ReportingDateTime": "",
              "CorrectiveAction": "",
              "FaultMessage": {
                "Code": "",
                "Text": "",
                "Severity": "",
                "Stack": "",
                "FaultCode": "",
                "FaultDescription": "",
                "FaultSeverity": "",
                "FaultTrace": "",
                "FaultCategory": ""
              },
              "FaultingService": {
                "ID": "",
                "ImplementationCode": "",
                "InstanceID": "",
                "ProjectName": "",
                "ServiceName": "",
                "ActivityName": "",
                "CompositeName": "",
                "ComponentName": ""
              }
            },
            "MessageBatch": {
              "ID": "",
              "Name": "",
              "StatusCode": "",
              "ResponseMessage": "",
              "BatchParameter": {
                "Name": "",
                "DataTypeCode": "",
                "Value": ""
              }
            },
            "MessageTracking": {
              "SequenceNumber": "",
              "ExecutionUnitID": "",
              "ExecutionUnitName": "",
              "ImplementationCode": "",
              "ActivityDateTime": "",
              "IntermediateMessageHop": {
                "SenderResourceTypeCode": "",
                "SenderResourceID": "",
                "SenderMessageID": "",
                "IntermediateMessageHop": ""
              }
            },
            "CompanyCode": "",
            "OrganisationCode": "",
            "Action": "",
            "UserID": "",
            "UserArea": {
              "KeyName": "",
              "Value": ""
            }
          },
          "DataArea": {
            "BulkConfig": payloadBulkConfig
          }
        }
      },
      'type': "SUBMIT",
      "processedTags": selectedTagsList
    }


    return payload;
  }


  const configBulkLineHandler = () => {
    gridApi.stopEditing()
    // let selectedRows = gridApi.getSelectedRows();
    //let selectedData = selectedNodes.map(node => node.data);

    // if (selectedRows.length === 0) {
    //   toastr.error('Please select the tag line')
    //   return
    // }
    // else if (selectedRows.length === 1) {
    //   toastr.error('Please select multiple tag line')
    //   return
    // }


    // else if ((selectedRows.some(ele=> (ele.gen_base_model_1 == "" || ele.gen_base_model_1 == null) ) )
    //   && (selectedRows.some(ele=> (ele.pur_mod_num_part1 == "" || ele.pur_mod_num_part1 ==null ) ) )
    // ) {
    //   toastr.error('Base Model 1 and Model Number 1 can not be empty')
    // }

    //if (bulkConfigTagValidHandler()) {

    // const newTags = tagDataList?.map((tag) => {

    //   const bulkConfigProcessTag = selectedRows.some((ele) => ele.tag_id === tag.tag_id)
    //   if (bulkConfigProcessTag) {
    //     return { ...tag, isDisabled: true, status: "PENDING", }
    //   } else {
    //     return { ...tag, isDisabled: false }
    //   }

    // })

    //const selectedRows1 = selectedRows.map((tag) => ({ ...tag, isBulkConfgProgress: true, status: "PENDING", project_name: ctrl.data.project_name, package_name: ctrl.pkg.package_name }));
    const displayedRows = gridApi.getDisplayedRowCount();

    const orderedSelectedTags = [];

    for (let i = 0; i < displayedRows; i++) {
      const rowNode = gridApi.getDisplayedRowAtIndex(i);
      if (rowNode && rowNode.isSelected()) {
        orderedSelectedTags.push(rowNode.data);
      }
    }

    dispatch(bulkTagConfigStart(bulkConfigTagPayload(orderedSelectedTags.length > 150 ? orderedSelectedTags.slice(0, 150) : orderedSelectedTags)))



    // const rahulData = {
    //   "I_BULK_CONFIG": [
    //     {
    //       "MODEL": "",
    //       "MODEL_STRING": "485G020ZSHPS1T10008RL",
    //       "MODEL_NAME_1": "",
    //       "MODEL_STRING_1": "",
    //       "MODEL_NAME_2": "",
    //       "MODEL_STRING_2": "",
    //       "MODEL_NAME_3": "",
    //       "MODEL_STRING_3": "",
    //       "MODEL_NAME_4": "",
    //       "MODEL_STRING_4": "",
    //       "MODEL_NAME_5": "",
    //       "MODEL_STRING_5": "",
    //       "MODEL_NAME_6": "",
    //       "MODEL_STRING_6": "",
    //       "MODEL_NAME_7": "",
    //       "MODEL_STRING_7": "",
    //       "QUANTITY": "2",
    //       "CURRENCY_CODE": "USD",
    //       "PRICING_REGION": "US",
    //       "DIVISION": "RMT",
    //       "CUSTOMER_NAME": "EMERSON CLIMATE TECHNOLOGIES (SUZHOU) CO LTD",
    //       "MAIL_ID": "harjot.singh@emerson.com",
    //       "PROJECT_NAME": "Project-harjot-1",
    //       "PACKAGE_ID": "1234",
    //       "TECHNOLOGY_ID": "1234",
    //       "TAG_ID": "9013",
    //       "CONFIGHEADERID": "",
    //       "CONFIGREVNUMBER": "",
    //       "ACTIONIDENTIFIER": "",
    //       "PRICE_DATE": "02-MAY-2024",
    //       "PRICE_LIST": "RMT CORPORATE OCT 2023",
    //       "QUOTE_HEADER_ID": "",
    //       "QUOTE_LINE_ID": "",
    //       "SIZE_REFERENCE_ID": "",
    //       "SOURCE": "PRJWSC",
    //       "END_DESTINATION": "",
    //         "HOST_HEADER_ID": "",
    //       "TRANSACTION_TYPE": "Project_DESC1",
    //       "QUOTE_NAME": "PRJWS Testing Harjot",
    //             "PART_NUMBER": "R-485",
    //       "ORG_ID": "4150",
    //       "PARTY_ID": "3963706",
    //       "CUSTOMER_ACCOUNT_ID": "887010",
    //       "INVOICE_TO_PARTY_ID": "1325502",
    //       "SHIP_TO_PATY_ID": "1325502"
    //     }
    //   ]
    // }

    // dispatch(bulkTagConfigStart(rahulData))

    //}
  }

  const configBlkStatusShowHandler = () => {
    setOpenBulkConfigStatus(prev => !prev);
  }

  // const isRowSelectableTagGrid = useCallback((params) => {
  //   //return !params.data?.isBulkConfgProgress && isCellEditable
  //   let editFlag = isCellEditable
  //   //console.log("values:", params.data)
  //   if (params.data?.isBulkConfgProgress || params.data?.gen_costing_status == "IN PROCESS") {
  //     editFlag = false
  //   }
  //   return editFlag

  // }, [isCellEditable,tagDataList]);
  const isRowSelectableTagGrid = (params) => {
    //useCallback((params) => {
    //let editFlag = (+slctRev?.value === +ctrl.pkg.active_revision)
    // console.log(params.data?.gen_costing_status)
    let editFlag = true;
    //  console.log("--params--", params);
    //  console.log("--params.data--", params.data);
    //  console.log("--params.data?.isBulkConfgProgress--", params.data?.isBulkConfgProgress);
    //  console.log("--params.data?.gen_costing_status--",params.data?.gen_costing_status);

    if (params.data?.config_status?.includes("INPROCESS") || (params.data?.gen_costing_status?.trim().toUpperCase() ?? '') === "IN PROCESS") {
      editFlag = false
    }
    return editFlag

  }
  //, [slctRev, ctrl.pkg.active_revision]);
  const handleTabChange = (_, newValue) => {
    dispatch(changeWSTab(newValue))
    if (newValue == 'Instrumentation') {
      handleDatasetChange('Common')
    } else {
      handleDatasetChange(newValue)
    }
  }


  const cancelCmtConfirmBox = () => {
    setRevComments('');
    setEditingCommentId(null);
    setInlineEditMap({});
    setOpenCmtConfirm(prev => !prev)
  }

  return (
    <>
      {/*
check the association of child with parent
*/}
      <Dialog open={removeChildAssociation.showConfirmation} className="create-project tags-modal muiForm-Modal" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title" >
        <DialogTitle className="model-title" id="draggable-dialog-title">
          <div className="d-flex">
            <div>{t('Confimation!')}</div>
            <div className="ml-auto close-MUIModal" onClick={() => { setRemoveChildAssociation(false) }}>

            </div>
          </div>

        </DialogTitle>
        <DialogContent>   <div className='pb-3'>  {removeChildAssociation.message} </div>
        </DialogContent>
        <DialogActions className="model-actions">
          <Button className="sbtn btn btn-secondary " sx={{ boxShadow: 0 }} variant="contained" color="success" onClick={(e) => continueRemoveAssociation()}>{t('Continue')}</Button>
          <Button className="cnbtn btn btn-outline-success" variant="outlined" onClick={(e) => { setRemoveChildAssociation(false); }}> {t('Cancel')} </Button>

        </DialogActions>
      </Dialog>

      {/*
--------------------------------------------------------
*/}


      <Dialog open={tagState.showPkg} className="create-project tags-modal muiForm-Modal" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title" >
        <DialogTitle className="model-title" id="draggable-dialog-title">
          <div className="d-flex">
            <div> {t('Warning')} </div>
            <div className="ml-auto close-MUIModal" onClick={() => { setTagState(false) }}>
              <MdClose />
            </div>
          </div>

        </DialogTitle>
        <DialogContent>   <div className='pb-3'> {tagState.message} </div>
        </DialogContent>

      </Dialog>


      <Dialog open={confPaste}
        fullWidth
        maxWidth="sm"
        className="create-project tags-modal muiForm-Modal confirmModal"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title" >
        {!showConfirmData && <DialogTitle className="model-title" id="draggable-dialog-title">
          <div className="d-flex">
            {dispatchTagSize <= dispatchSize && <div> {t('Please Confirm')}  </div>}
            {dispatchTagSize > dispatchSize && <div> {t('Please Cancel')} </div>}
          </div>
        </DialogTitle>}
        <DialogContent>

          {showConfirmData && <div className='mb-4 mt-4'> {t('Loading...')} </div>}
          {!showConfirmData && <div className='pb-3 confirmModal-content'>

            <ul>
              {dispatchTagSize <= dispatchSize && <li><p>
                {/* // The process can be undone upto {undoLimit} time, unless you leave the page.  */}
                {t('You are changing existing data and cannot undo.')}
              </p>
                <p>
                  <b> {t('Note')} : </b> {t('Valid Configurations will require re-size and re-configuration')}
                </p>
              </li>}
              {dispatchTagSize > dispatchSize && <li><p> {t('Maximum limit to update the tags is')}  {dispatchSize}. </p></li>}

            </ul>
            {dispatchTagSize <= dispatchSize &&
              <p className='mt-0'>
                {t('Would you like to proceed?')}
              </p>}
          </div>}
        </DialogContent>
        <DialogActions className="copy-project-model-footer" style={{ paddingRight: "16px" }}>
          <Button outline color="success" onClick={cancelPasteTags}>
            {t('Cancel')}
          </Button>
          {!showConfirmData && dispatchTagSize <= dispatchSize && <Button className="sbtn btn btn-secondary" onClick={savePasteTags} >
            <span> {t('Save')} </span>
          </Button>}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCmtConfirm}
        onClose={() => setOpenCmtConfirm(false)}
        fullWidth
        maxWidth="md"
        className="create-project tags-modal muiForm-Modal rev-comments-modal"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle className="model-title" id="draggable-dialog-title">
          <div className="d-flex">
            <div>{`Revision Comments | R-${slctRev?.value}`}</div>
          </div>
        </DialogTitle>
        <DialogContent ref={commentDialogContentRef}>
          <div>
            <div>
              <TextField
                inputRef={commentInputRef}
                label={`Add Comment for Revision ${slctRev?.value}`}
                multiline
                size="small"
                value={revComments}
                inputProps={{ maxLength: 500 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        className="rev-comments-modal__adornment-btn"
                        disabled={revComments.trim() === ""}
                        onClick={addPackageComments}
                      >
                        <IoCheckmarkDoneSharp size={14} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                helperText={`${revComments.length}/500`}
                error={revComments.length >= 500}
                onChange={(event) => setRevComments(event.target.value)}
              />
            </div>

            <div>
              <div>
                {selectedPkgCmnts?.length > 0 && <List className="rev-comments-modal__list">{selectedPkgCmnts?.map((item, index) =>
                  <ListItem className="rev-comments-modal__list-item" key={item.revision_id}
                    ref={index === selectedPkgCmnts.length - 1 ? lastRevCmtItemRef : null}
                    divider>
                    {editingCommentId === item.revision_id ? (
                      <div className="rev-comments-modal__inline-editor">
                        <TextField
                          multiline
                          size="small"
                          value={inlineEditMap[item.revision_id] ?? ''}
                          inputProps={{ maxLength: 500 }}
                          helperText={`${(inlineEditMap[item.revision_id] || '').length}/500`}
                          error={(inlineEditMap[item.revision_id] || '').length >= 500}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  className="rev-comments-modal__adornment-btn"
                                  onClick={() => cancelInlineEdit(item.revision_id)}
                                >
                                  <MdClose size={14} />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  className="rev-comments-modal__adornment-btn"
                                  disabled={!(inlineEditMap[item.revision_id] || '').trim()}
                                  onClick={() => saveInlineEdit(item)}
                                >
                                  <IoCheckmarkDoneSharp size={14} />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                          onChange={(event) => handleInlineEditChange(item.revision_id, event.target.value)}
                        />
                      </div>
                    ) : (
                      <>
                        <StyledTooltip
                          title={
                            <div style={{ whiteSpace: 'nowrap', lineHeight: 1.5 }}>
                              {`Last Updated By: ${item.last_updatedby || 'N/A'} (${item.last_updatedate ? dateFmtToStr(item.last_updatedate) : 'N/A'})`}
                              <br />
                              {`Created By: ${item.created_by || 'N/A'} (${item.creation_date ? dateFmtToStr(item.creation_date) : 'N/A'})`}
                            </div>
                          }
                          placement="right"
                          disableInteractive
                          componentsProps={{
                            tooltip: {
                              sx: {
                                maxWidth: 'none',
                              },
                            },
                          }}
                        >
                          <ListItemText
                            primary={
                              <Typography className="rev-comments-modal__comment-text">
                                {item.revision_comments}
                              </Typography>
                            }
                          />
                        </StyledTooltip>
                        {Number(item.revision_number) === Number(ctrl.pkg.active_revision) && (
                          <div style={{ display: 'flex', alignItems: 'center' }} >
                            <IconButton size="small" style={{ color: COLORS.orange }} onClick={() => handleEditComment(item)}>
                              <FiEdit2 size={14} />
                            </IconButton>
                            <IconButton size="small" style={{ color: COLORS.red }} onClick={() => openDeleteCommentConfirm(item)}>
                              <FiTrash2 size={14} />
                            </IconButton>
                          </div>
                        )}
                        {/* <div style={{ display: 'flex', alignItems: 'center' }} >
                          <IconButton size="small" style={{color: COLORS.orange}} onClick={() => handleEditComment(item)}>
                            <FiEdit2 size={14} />
                          </IconButton>
                          <IconButton size="small" style={{color: COLORS.red}} onClick={() => openDeleteCommentConfirm(item)}>
                            <FiTrash2 size={14} />
                          </IconButton>
                        </div> */}
                      </>
                    )}
                  </ListItem>
                )}
                </List>}
                {(!selectedPkgCmnts || selectedPkgCmnts.length === 0) && (
                  <div className="rev-comments-modal__empty-state">{t('No comments added yet.')}</div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="model-actions">
          <button className="cnbtn btn cancel-btn" variant="outlined" onClick={cancelCmtConfirmBox}>
            Close
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={commentDeleteConfirmOpen}
        onClose={cancelDeleteCommentConfirm}
        fullWidth
        maxWidth="sm"
        className="create-project tags-modal muiForm-Modal"
        PaperComponent={PaperComponent}
        aria-labelledby="delete-comment-confirm-title"
      >
        <DialogTitle className="model-title" id="delete-comment-confirm-title">
          {t('Confirm Delete')}
        </DialogTitle>
        <DialogContent>
          <div className="pb-3">
            {t('Are you sure you want to delete this comment?')}
          </div>
        </DialogContent>
        <DialogActions className="model-actions">
          <button className="cnbtn btn cancel-btn" variant="outlined" onClick={cancelDeleteCommentConfirm}>
            {t('Cancel')}
          </button>
          <button className="sbtn btn btn-secondary" onClick={confirmDeleteComment}>
            {t('Delete')}
          </button>
        </DialogActions>
      </Dialog>

      {/* <DeleteTag tagsLoaded={tagsLoaded} setTagsLoaded={setTagsLoaded} 
      delClick={delClicked} showProgressBar={showProgressBar} 
      fetchtagPBarCount={fetchtagPBarCount} clickFrom={clickFM} 
      selectedDeletedData={selectedDeletedData} columnDefs={colDefinations} 
      defaultColDef={gridDefinition.defaultColDef} clickFromDeletedTag={clickFromDeletedTag} 
      restoreActive={restoreActive} rowData={tagDataList} selectedRows={selectedRowsData} 
      resChild={getResdelClick} /> */}
      <DeleteTag delClick={delClicked} showProgressBar={showProgressBar} fetchtagPBarCount={fetchtagPBarCount} clickFrom={clickFM} selectedDeletedData={selectedDeletedData} columnDefs={colDefinations} defaultColDef={gridDefinition.defaultColDef} clickFromDeletedTag={clickFromDeletedTag} restoreActive={restoreActive} rowData={tagDataList} selectedRows={selectedRowsData} resChild={getResdelClick} />

      {(!showProgressBar) && <ReportHub click={clicked} clickChild={clickFromStatus} reportStatus={openReportStatus} selectedRows={selectedRowsData} revision={slctRev} />}
      <SelectReportType open={openSelectReportType} onClose={() => setOpenSelectReportType(false)}
        selectedRowsData={selectedRowsData} revision={slctRev}
      />
      <BatchReportStatusModal
        open={openBatchReportStatus}
        onClose={() => setOpenBatchReportStatus(false)}
        packageId={ctrl.pkg.package_id}
        revision={slctRev?.value || ctrl.pkg.active_revision}
      />
      {/* <BulkConfig configBlkStatusShow={configBlkStatusShowHandler} openBulkConfigStatus={openBulkConfigStatus} /> */}
      {openBulkConfigStatus && <BulkConfig configBlkStatusShow={configBlkStatusShowHandler} openBulkConfigStatus={openBulkConfigStatus} />}
      {/* <ConfigDet click={clickedCon} selectedRows={selectedRowsData}/> */}
      <div id="inputgrid"  /*style={{height:window.innerHeight-90, width:"100%"}} */ className="ag-theme-alpine tagTreeG">



        {/* <Row>  {pkgs !== undefined && pkgs !== null &&
                     <div className='pckg-counter-div'> */}

        {/* old commented code */}
        {/* <div className='pckg-counter-item-div' style={{position:'relative'}}>
                        <span style={{color:'#00aa7e'}}>All ({pkgs.length}) </span>
                        <MdClose className='pckg-counter-close-btn' onClick={()=>handlePkgsSlctn(pkgs)} />
                     </div> */}

        {/* {alltagBadge}

                        {
                           gtechTyps.length > 0 && gtechTyps.map((techType) => {
                              let tagCount = 0
                              if (slctdPkgTags !== null && slctdPkgTags !== undefined && slctdPkgTags.length > 0) {
                                 return slctdPkgTags.map((elem, index) => {
                                    if (elem.tags.length <= 0) {
                                       return;
                                    }

                                    for (let i = 0; i < elem.tags.length; i++) {
                                       if (techType.technology_id == elem.tags[i].technology_id &&
                                          techType.project_id == elem.tags[i].project_id &&
                                          techType.package_id == elem.tags[i].package_id) { tagCount = tagCount + 1 }
                                    }

                                    if (tagCount > 0) {
                                       return (
                                          <div key={index} className='pckg-counter-item-div' style={{ position: 'relative' }}>
                                             <span style={{ color: '#00aa7e', marginRight: 12 }}>{getTTLabel(techTyps, techType.technology_name)} ({tagCount}) </span>
                                             <MdClose className='pckg-counter-close-btn' onClick={() => handleTechSlctn(techType)} />
                                          </div>
                                       )
                                    }
                                 }
                                 )
                              }
                           }
                           )
                        }



                     </div>
                  }
                  </Row> */}


        {/* second badges ui implement */}

        {/* <Row>
                     <div className='tag-badges-container'>{pkgs !== undefined && pkgs !== null &&
                        <div className='pckg-counter-div' onScroll={pckgBadgesScroll} ref={pckgCouterBadges} >

                           {alltagBadge}


                           {
                              gtechTyps.length > 0 && gtechTyps.map((techType) => {
                                 let tagCount = 0
                                 if (slctdPkgTags !== null && slctdPkgTags !== undefined && slctdPkgTags.length > 0) {
                                    return slctdPkgTags.map((elem, index) => {
                                       if (elem.tags.length <= 0) {
                                          return;
                                       }
                                       for (let i = 0; i < elem.tags.length; i++) {
                                          if (techType.technology_id == elem.tags[i].technology_id &&
                                             techType.project_id == elem.tags[i].project_id &&
                                             techType.package_id == elem.tags[i].package_id) { tagCount = tagCount + 1 }
                                       }
                                       if (tagCount > 0) {
                                          return (
                                             <div key={index} className='pckg-counter-item-div' style={{ position: 'relative' }}>
                                                <span style={{ color: '#00aa7e', marginRight: 12 }}>{getTTLabel(techTyps, techType.technology_name)} ({tagCount}) </span>
                                                <MdClose className='pckg-counter-close-btn' onClick={() => handleTechSlctn(techType)} />
                                             </div>
                                          )}
                                    }
                                    )}
                              }
                              )}

                        </div>

                     }</div>
                     {isBadgesScrollEnbl && <div className='tag-badges-scroll-cntrs'>
                        <div style={{ position: "relative", top: "10%" }}>
                        
                           <IconButton color="success" {...backspaceLongLeftPress} onClick={arrowLeft} disabled={badgesHScroll === 0} aria-label="add to shopping cart">
                              <IoIosArrowBack />
                           </IconButton>

                           <IconButton color="success" {...backspaceLongRightPress} onClick={arrowRight} disabled={badgesHScroll === 100} aria-label="add to shopping cart">
                              <IoIosArrowForward />
                           </IconButton>

                        </div></div>}
                  </Row> */}


        {/* <div className='d-flex' style = {{paddingBottom: '5px', paddingTop: '5px'}}
                <Select styles={MultiTagComboStyle} menuPortalTarget={document.body} 
                  name="exist_pkgs"  options={eprojs.getPkgs} placeholder='Package...'/>                                        
                  </div>*/}


        <Tabs className='tagGridTab' value={wsTabValue} onChange={handleTabChange}>
          <Tab label={t('Instrumentation')} value={'Instrumentation'} disabled={isTabsActive} />
          <Tab label={t('Documents & Order Services')} value={'Documents & Order Services'} disabled={isTabsActive} />
          <Tab label={t('Buy Resale')} value={'Buy Resale'} disabled={isTabsActive} />
          <Tab label={t('Accs, Parts & Spares')} value={'Accs, Parts & Spares'} disabled={isTabsActive} />
        </Tabs>
        <Grid container className="marginRow px-2 tags-main" spacing={1}>
          <Grid item md={12} sm={12} xs={12} className='gridHdr'>
            <Grid container className="align-items-center h-100" spacing={1}>
              <Grid item md={8} sm={8} xs={8} className='gridHdr gen'>


                {
                  isInstrumentationTab &&
                  <>
                    <div className='add_pkg_comment'>
                      <StyledTooltip title={t('Add Package Comments')} placement="bottom" disableInteractive><label><TfiCommentAlt className={(showProgressBar || prof.capb.findIndex((o) => o.PWSACCON === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2 add_pkg_comment_button'} onClick={(showProgressBar || prof.capb.findIndex((o) => o.PWSACCON === 'Y') < 0 || !writeAcc) ? disRev : startNewComment} /></label></StyledTooltip>
                    </div>
                    <div className='Rev_badg_Cont'>
                      {/* <div className='RevLabel'>
                    <label>{t('Revision')}</label>
                  </div> */}
                      <div className='revisonSelect'>
                        {slctRev &&
                          <Autocomplete
                            size="small"
                            options={reviSelectOptn}
                            isOptionEqualToValue={(option, value) => option?.value == value?.value}
                            renderInput={(params) => <TextField {...params} label={t('Revision')} />}
                            getOptionLabel={(option) => (option.value ? option.value + "" : "")}
                            // defaultValue={reviSelectOptn[0]}
                            defaultValue={slctRev || ""}
                            //prevvalue={ctrl.pkg.active_revision}
                            onChange={(event, e) => {
                              console.log(e)
                              setSaveStateBOl(false); onChangeRev(e);
                              saveState();

                              setSelDataset('Common');
                              // setTimeout(() => {
                              //   setData(selDataset);
                              // }, 10);
                              setSelectedRowsData(undefined);
                            }}
                          />
                        }

                      </div>
                    </ div>

                    <div className='lookupDropdown'>
                      {/* <div className='RevLabel'>
                    <label>{t('Technology')}</label>
                  </div> */}
                      <div className='lookupSelect' >
                        <Autocomplete
                          size="small"
                          disabled={showProgressBar}
                          renderInput={(params) => <TextField {...params} label={t('Technology')} />}
                          options={techNames}
                          value={commonDS ? selDataset : ''}
                          onChange={(event, e) => handleDatasetChange(e)}
                        />
                      </div>
                    </div>
                  </>
                }


                {showProgressBar && !restoreActive && <label style={{ fontSize: "12px", color: "gray", marginTop: "6px", marginLeft: "6px" }}> {t('Total Records:')} {(fetchedDataCnt > 0 && tags.length > 0 && fetchedDataCnt != gettagcntTl) && `${fetchedDataCnt}/`}{tags.length > 0 ? gettagcntTl : "0"}</label>}

                {(!showProgressBar || restoreActive) && isInstrumentationTab && <div className='scrollerNav' style={{ marginLeft: "3px", display: "flex" }}>
                  {isBadgesScrollEnbl &&

                    <IconButton sx={{ color: COLORS.green }} {...backspaceLongLeftPress} onClick={arrowLeft} disabled={badgesHScroll === 0} aria-label="technology names">
                      <IoIosArrowBack />
                    </IconButton>

                  }

                  {<div className='tag-badges-container'>{pkgs !== undefined && pkgs !== null &&
                    <div className='pckg-counter-div' onScroll={pckgBadgesScroll} ref={pckgCouterBadges} >

                      {/* {alltagBadge} */}
                      <AllTagBadge />
                      {/* {allTesttagBadge} */}

                      {
                        gtechTyps.length > 0 && gtechTyps.filter(i => !commercialTypes.includes(i.technology_name)).map((techType) => {
                          let tagCount = 0
                          if (slctdPkgTags !== null && slctdPkgTags !== undefined && slctdPkgTags.length > 0) {
                            return slctdPkgTags.map((elem, index) => {
                              if (elem.tags.length <= 0) {
                                return;
                              }
                              for (let i = 0; i < elem.tags.length; i++) {
                                if (techType.technology_id == elem.tags[i].technology_id &&
                                  techType.project_id == elem.tags[i].project_id &&
                                  techType.package_id == elem.tags[i].package_id) { tagCount = tagCount + 1 }
                              }
                              if (tagCount > 0) {
                                return (
                                  <div key={index} className='pckg-counter-item-div' style={{ position: 'relative' }}>
                                    <span style={{ color: COLORS.green, marginRight: 12 }}>{techType.product_description} ({tagCount}) </span>
                                    <MdClose className='pckg-counter-close-btn' onClick={() => handleTechSlctn(techType)} />
                                  </div>
                                )
                              }
                            }//getTTLabel(techTyps, techType.technology_name)
                            )
                          }
                        }
                        )}

                    </div>

                  }</div>}
                  {isBadgesScrollEnbl &&

                    <IconButton sx={{ color: COLORS.green }} {...backspaceLongRightPress} onClick={arrowRight} disabled={badgesHScroll === 100} aria-label="add to shopping cart">
                      <IoIosArrowForward />
                    </IconButton>

                  }
                </div>}

              </Grid><Grid item md={4} sm={4} xs={4} className='gridHdr'>
                <div className='right-Actions' style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>


                  {/* <StyledTooltip title='Pricing' placement="bottom" disableInteractive>
                    <label>
                      <AiOutlineDollar className={(profileState?.bu !== 'Isolation Valves' || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACPRC === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(profileState?.bu !== 'Isolation Valves' || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACPRC === 'Y') < 0 || !writeAcc) ? disRev : handleClickPricing} />
                    </label>
                  </StyledTooltip>
                  <Popover
                    id={idPricing}
                    open={openPricing}
                    anchorEl={anchorPricing}
                    onClose={handleClosePricing}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >

                    <Typography sx={{ p: 2 }}>
                      <div className='reportdd'>
                        <span className='link_report' onClick={pricingbtn}> Import to PPA </span>
                        <span className='link_report' onClick={handleLinkClick}>Launch PPA</span>
                        <span className='link_report' onClick={bothPPA}> Import and Launch </span>
                      </div>


                    </Typography>
                  </Popover> */}




                  {/* filter */}
                  {/* <StyledTooltip title={t('Filter')} placement="bottom" disableInteractive>
                    <label>
                      <FiFilter className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={() => { if (showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) { disRev(); } else { setffActive(!ffActive); setData(selDataset); } }} /> </label>
                  </StyledTooltip>
                 
                  </StyledTooltip> */}
                  {/* ----------------- */}
                  <div className='reportDropdown'>
                    <StyledTooltip title={t('Filter')} placement="bottom" disableInteractive >
                      <label>
                        <FiFilter
                          aria-describedby={idFilter}
                          onClick={(showProgressBar || prof.capb.findIndex((o) => o.PWSDELTAG === 'Y') < 0 || !writeAcc) ? disRev : handleClickFilter}
                          className={(showProgressBar || prof.capb.findIndex((o) => o.PWSDELTAG === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'}
                        />
                      </label>
                    </StyledTooltip>
                    <Popover
                      id={idFilter}
                      open={openFilter}
                      anchorEl={anchorFilter}
                      onClose={handleCloseFilter}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}

                    >
                      <Typography sx={{ p: 2 }}>
                        <div className='reportdd'>
                          <span className='link_report' onClick={() => {
                            if (showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) { disRev(); } else {
                              setffActive(!ffActive);
                              // setData(selDataset);
                              handleCloseFilter();
                            }
                          }}>{t('Filter')}  </span>
                          <span className='link_report' onClick={() => { clearFilters(); handleCloseFilter(); }}> {t('Clear Filters')} </span>
                          <span className='link_report' onClick={() => { resetState(); handleCloseFilter(); }}> {t('Reset Columns')} </span>
                        </div>
                      </Typography>
                    </Popover>
                  </div>
                  {/* filter */}

                  {!isInstrumentationTab &&
                    <StyledTooltip title={t('Link Tag')} placement="bottom" disableInteractive>
                      <label>
                        <FaLink className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACCON === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'}
                          onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACCON === 'Y') < 0 || !writeAcc) ? disRev : onClickLinkTag}
                        />
                      </label>
                    </StyledTooltip>
                  }

                  <div className='reportDropdown'>
                    <StyledTooltip title={t('Delete')} placement="bottom" disableInteractive ><label>
                      <RiDeleteBin6Line
                        aria-describedby={idDelete}
                        className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSDELTAG === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'}
                        onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSDELTAG === 'Y') < 0 || !writeAcc) ? disRev : handleClickDelete} /> </label></StyledTooltip>
                    <Popover
                      id={idDelete}
                      open={openDelete}
                      anchorEl={anchorDelete}
                      onClose={handleCloseDelete}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}

                    >
                      <Typography sx={{ p: 2 }}>
                        <div className='reportdd'>
                          <span className='link_report' onClick={() => { deleteClick(); handleCloseDelete(); }}> {t('Delete Tags')} </span>
                          <span className='link_report' onClick={() => { getDeletedTags(); handleCloseDelete(); destroyFn(); }}> {t('Archive Screen')} </span>
                        </div>
                      </Typography>
                    </Popover>
                  </div>



                  {
                    isInstrumentationTab &&
                    <div className='reportDropdown'>

                      <StyledTooltip title={t('Report')} placement="bottom" disableInteractive ><label><TbReportAnalytics aria-describedby={idReport} className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSRTTAG === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSRTTAG === 'Y') < 0 || !writeAcc) ? disRev : handleClickReport} /> </label></StyledTooltip>

                      <Popover
                        id={idReport}
                        open={openReport}
                        anchorEl={anchorReport}
                        onClose={handleCloseReport}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}

                      >
                        <Typography sx={{ p: 2 }}>
                          <div className='reportdd'>
                            {/* <span className='link_report' onClick={reportClick}> {t('Get Report')}  </span>
                            <span className='link_report' onClick={viewReportStatusClick}> {t('View Report Status')}  </span> */}
                            <span className='link_report' onClick={selectReportTypeClick}> {t('Batch Report')}  </span>
                            <span className='link_report' onClick={batchReportStatusClick}> {t('Batch Report Status')}  </span>
                          </div>


                        </Typography>
                      </Popover>
                    </div>
                  }



                  {isInstrumentationTab && <StyledTooltip title={t('Copy')} placement="bottom" disableInteractive ><label><FiCopy className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSCPTAG === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSCPTAG === 'Y') < 0 || !writeAcc) ? disRev : handleCopyValidate} /> </label></StyledTooltip>}
                  {isInstrumentationTab && <StyledTooltip title={t('Size')} placement="bottom" disableInteractive ><label><RiRulerLine className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? disRev : sizeTag} /> </label></StyledTooltip>}
                  <StyledTooltip title={t('Configure')} placement="bottom" disableInteractive><label><MdOutlineHandyman className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACCON === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACCON === 'Y') < 0 || !writeAcc) ? disRev : configLine} /></label></StyledTooltip>
                  <StyledTooltip title={t('Config Detail')} placement="bottom" disableInteractive><label><BsListTask className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACPRC === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACPRC === 'Y') < 0 || !writeAcc) ? disRev : configDet} /></label></StyledTooltip>

                  {/* <StyledTooltip title='Export' placement="bottom" disableInteractive><label><FiUpload className={(slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') <0 ) && showProgressBar  ? 'tag-grid-head-cntrl-dis mx-2':'tag-grid-head-cntrl mx-2'} onClick={(slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') <0 )  ? disRev:exportMultiSheets} /></label></StyledTooltip> */}
                  <StyledTooltip title={t('Export')} placement="bottom" disableInteractive><label><FiUpload className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') < 0 || !writeAcc) ? disRev : exportGrid} /></label></StyledTooltip>

                  {/* <CustomTooltip content="Size" direction="bottom"> <label><TbTextResize className='mx-2 tag-grid-head-cntrl' onClick={sizeTag} /> </label> </CustomTooltip>
                                      <CustomTooltip content="Configure" direction="bottom"> <label><BsGearWideConnected className='mx-2 tag-grid-head-cntrl' onClick={configLine} /></label></CustomTooltip>
                                      <CustomTooltip content="Config Detail" direction="bottom"> <label><AiFillTool className='mx-2 tag-grid-head-cntrl' onClick={configDet} /></label></CustomTooltip>
                                      <CustomTooltip content="Export" direction="bottom"> <label><TiExport className='mx-2 tag-grid-head-cntrl' onClick={exportMultiSheets} /></label></CustomTooltip> */}

                  <div className='dropTagMain'>
                    <StyledTooltip title={t('Bulk Operations')} placement="bottom" disableInteractive><label style={{ cursor: "pointer" }}>
                      <Button
                        className={dataLoaded ? 'border-0 p-0' : 'border-0 p-0 disabled'} style={{ backgroundColor: 'transparent', boxShadow: 'none' }} onClick={handleClickDROPMulti}
                        // toggle={(slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSUPTAG === 'Y') <0 ||!writeAcc ) ? disRev:() => toggleStatus()}
                        disabled={
                          slctRev?.value != ctrl.pkg.active_revision ||
                          prof.capb.findIndex((o) => o.PWSUPTAG === "Y") < 0 ||
                          !writeAcc
                        }
                      >
                        <AiFillFilter className={(slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSUPTAG === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} />
                      </Button> </label></StyledTooltip>
                    {dataLoaded && <Popover
                      id={id}
                      open={open}
                      anchorEl={multiTagDrop}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <div className='dwbtnm tagDropdown'>
                        <div className='dwbtnm'>
                          {tagStatusNew && <div className='tagStatusSelect'>
                            <Select onChange={(e) => tagStatusChange(e)} options={tagStatusNew} styles={tagStyle} /> </div>}
                        </div>
                        {tsActnVal && (<>
                          <div className="dropdown-divider2"></div>
                          <div className='dwbtnm'>
                            {tsActnVal && <div className='tagStatusSelect'>
                              <Select onChange={(e) => tsActionChange(e)} options={tsActnVal} styles={tagStyle} /> </div>}
                          </div>
                        </>)}
                      </div>
                    </Popover>}
                  </div>
                  {/* <div className='reportDropdown'>
                  <StyledTooltip title='More' placement="bottom" disableFocusListener disableInteractive

                    leaveTouchDelay={100}

                  > */}


                  <IconButton
                    disabled={
                      showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSDELTAG === 'Y') < 0 || !writeAcc
                    }
                    style={{ height: "23px", width: "15px" }}>
                    <OptionMenu className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACPRC === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis ' : 'tag-grid-head-cntrl '}
                      configBulkLine={configBulkLineHandler}
                      configBulkDetails={configBlkStatusShowHandler}
                      bulkConfigTagValidHandler={bulkConfigTagValidHandler}
                      selectedRows={selectedConfigRowsData}
                      gridApi={gridApi}
                      setGridApi={setGridApi} />
                  </IconButton>




                  {/* </StyledTooltip> */}
                  {/* </div> */}

                  {/* 
                  <StyledTooltip title='Menu' placement="bottom" disableInteractive><label> 

                  {!openMenu && <FaSortAmountDownAlt className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') < 0 || !writeAcc) ? disRev : openMenuFN} />}
                  {openMenu && <FaSortAmountUpAlt className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACEXP === 'Y') < 0 || !writeAcc) ? disRev : openMenuFN} />}
                    
                    </label></StyledTooltip> */}


                  {/* <ButtonDropdown className={slctRev?.value != ctrl.pkg.active_revision ?'tag-grid-head-cntrl-dis mx-2':'tag-grid-head-cntrl mx-2'} isOpen={dwStatusOpen} toggle={(slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSUPTAG === 'Y') <0 ) ? disRev:() => toggleStatus()}
                                         // outline
                                         size="sm" >                                                                                                          
                                         <DropdownToggle className={dataLoaded ? 'border-0 p-0' : 'border-0 p-0 disabled' } style={{backgroundColor:'transparent', boxShadow:'none'}}>
                                            <AiFillFilter className={(slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSUPTAG === 'Y') <0 ) ?'tag-grid-head-cntrl-dis mx-2':'tag-grid-head-cntrl mx-2'}  />
                                  </DropdownToggle>
                                         <div className=''>
                                            <DropdownMenu className='dwbtnm tagDropdown'>
                                               <div className='dwbtnm'>
                                                  {tagStatusNew && <div className='tagStatusSelect'>
                                                     <Select onChange={(e) => tagStatusChange(e)} options={tagStatusNew} styles={tagStyle} /> </div>}
                                               </div>
                                               {tsActnVal && (<>
                                                  <DropdownItem divider />
                                                  <div className='dwbtnm'>
                                                     {tsActnVal && <div className='tagStatusSelect'>
                                                        <Select onChange={(e) => tsActionChange(e)} options={tsActnVal} styles={tagStyle} /> </div>}
                                                  </div>
                                               </>)}
                                            </DropdownMenu>
                                         </div>
                                      </ButtonDropdown> */}
                </div>

              </Grid>
            </Grid>

          </Grid>

          {/* {slctRev?.value == ctrl.pkg.active_revision && <Grid item md={12} sm={12} xs={12} className={(openMenu ? 'menuBottom show' : 'menuBottom')}>
            <div className='menuBottom_INN'>
          
            {restoreActive && <StyledTooltip title='Remove Deleted Tags' placement="bottom" disableInteractive ><label><LuFileMinus className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? disRev : removeDeletedTags} /> </label></StyledTooltip>}
            {restoreActive && <StyledTooltip title='Restore Tags' placement="bottom" disableInteractive ><label><FaTrashRestore className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? disRev : restoreClick} /> </label></StyledTooltip>}
         
 {!restoreActive && <StyledTooltip title='Get Deleted Tags' placement="bottom" disableInteractive ><label><LuFilePlus className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? disRev : getDeletedTags} /> </label></StyledTooltip>}
 {!restoreActive && <StyledTooltip title='Delete Tags' placement="bottom" disableInteractive ><label><RiDeleteBin6Line className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o) => o.PWSACSIZ === 'Y') < 0 || !writeAcc) ? disRev : deleteClick} /> </label></StyledTooltip>}
      
          </div>  
                </Grid> } */}

          <Grid item md={12} sm={12} xs={12}>
            {(showProgressBar && !restoreActive && tags.length > 0 && fetchedDataCnt != gettagcntTl) &&
              <div sm={12} md={12} lg={12}>
                <LinearProgress variant="determinate" value={fetchtagPBarCount || 0} /></div>}
            {loaderBar &&
              <div sm={12} md={12} lg={12}>
                <LinearProgress /></div>}
            {!destroy && <div className='gridHeight' >

              {/* {!destroy && <div style={{ height: openMenu ? "75vh" : "74vh" }}> */}
              {statusUpdate && <AgGridReact
                onCellClicked={e => onCellClicked(e)}
                groupHeaderHeight={25}
                ref={gridRef}
                overlayLoadingTemplate={'<div class="loadingx" style="margin: 7em"></div> <span class="ag-overlay-loading-center " style="font-size: 18px; z-index: 100000"> Loading Rows ...</span>'}
                //pivotGroupHeaderHeight={25}
                headerHeight={25}
                rowData={tagDataList}
                localeText={agGridTrans[localStorage.getItem("lang")]}
                // immutableData={true}
                //editable = {true}
                //columnDefs={gridDefinition.columnDefs}
                components={{ linPkgsRenderer: PkgSelRenderer, divSel: DivSel, tagStat: TagStatus }}
                // frameworkComponents={{ linPkgsRenderer: PkgSelRenderer, divSel: DivSel,tagStat:TagStatus }}
                columnDefs={colDefinations}
                defaultColDef={gridDefinition.defaultColDef}
                rowHeight={26}
                gridOptions={gridOptions}
                getRowId={ele => ele.data.tag_id}
                onCellValueChanged={(rec) => onCellValueChanged(rec)}
                onGridReady={onGridReady}
                rowSelection={"multiple"}
                stopEditingWhenCellsLoseFocus={true}
                enableRangeSelection={true}
                suppressCopyRowsToClipboard={true}
                undoRedoCellEditingLimit={undoLimit}
                onCellEditingStarted={onCellEditingStarted}
                onCellEditingStopped={onCellEditingStopped}
                excelStyles={excelStyles}
                undoRedoCellEditing={true}
                onSelectionChanged={onSelectionChanged}
                onColumnVisible={onColumnStateChanged}
                isRowSelectable={isRowSelectableTagGrid}
                tooltipShowDelay={0}
                tooltipHideDelay={3000}
              //onRowSelected={onRowSelected}
              // rowGroup={true}
              // getRowStyle={getRowStyleParentTable}
              // alignedGrids={
              //    grid_ImportFileRef.current ? [grid_ImportFileRef.current] : undefined
              // }

              //onCellClicked={(e) => onClickCell(e)}      
              //sideBar= {'filters'}

              />}

            </div>}
          </Grid>




        </Grid>

        {/* </div> */}



        {/* </Grid> */}

        {
          showCopyErrorPopup &&
          <Dialog open={showCopyErrorPopup} onClose={() => { setShowCopyErrorPopup(false); }} className="copy-model muiForm-Modal duplicate-tag-line-modal" PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title">
            <DialogTitle className="model-title mb-0" id="draggable-dialog-title">{t('Warning')}</DialogTitle>
            <DialogContent>
              <div style={{ paddingTop: '15px', fontSize: '16px' }}>
                {t('Any Selected Tags having PA Ref ID.')}

                <br />
                {t('Are you sure want to override them?')}
              </div>


            </DialogContent>
            <DialogActions className='model-actions'>
              <Button className="cnbtn btn btn-outline-success" variant="outlined" onClick={(e) => { setShowCopyErrorPopup(false); }} style={{ "marginRight": "5px" }}>
                {t('Cancel')}
              </Button>
              <Button className="sbtn btn btn-secondary right-space" variant="contained" color="success" onClick={(e) => { setShowCopyErrorPopup(false); handleCopyTags(); }}>
                {t('Yes')}
              </Button>
            </DialogActions>
          </Dialog>
        }
        {
          copySizingPopup &&
          <Dialog open={copySizingPopup} onClose={() => { copySizingClose() }} className="copy-configuration-model muiForm-Modal" PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title">
            <DialogTitle className="model-title mb-0 text-align-center" >
              <div className='header-row'>
                <div id="draggable-dialog-title" className='header-row-title '>{t('Select Tag Window')}</div>

                {/* <div className='suggetion d-flex'>
                  <div className='suggetion-child'>
                  </div>
                  <span>Associated Child</span>
                </div>  */}
                {/* <div className="header-row-icon">
              <StyledTooltip title='Copy' placement="bottom" disableInteractive><label><FiCopy className={(showProgressBar || removeIcon || removeIcon === null)? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={()=>{!removeIcon && removeIcon !==null && handleCopySizing();}} /></label></StyledTooltip>
               <StyledTooltip title='Remove' placement="bottom" disableInteractive><label><FiTrash2 className={(showProgressBar || !removeIcon )? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'} onClick={()=>{removeIcon && removeIcon !==null && handleRemoveChildTag();}} /></label></StyledTooltip>

              </div> */}
                {/* clear filter */}
                <StyledTooltip title={'Clear Filters'} placement="bottom" disableInteractive>
                  <label>
                    <LuFilterX
                      className="tag-grid-head-cntrl mx-2"
                      onClick={clearFilterschild}
                      style={{ cursor: "pointer" }}
                    />
                  </label>
                </StyledTooltip>
              </div>

            </DialogTitle>
            <DialogContent>
              <Grid container className="ag-theme-alpine marginRow muiForm mb-2 pt-3" spacing={1.4}>
                <Grid item md={12} xs={12}>
                  {/* <div style={{textAlign:'end', marginRight:'10px',marginBottom:'5px'}}>
                    <StyledTooltip title ='Copy' placement="bottom" disableInteractive ><label><FiCopy className={(showProgressBar || slctRev?.value != ctrl.pkg.active_revision || prof.capb.findIndex((o)=> o.PWSACSIZ === 'Y')< 0 || !writeAcc)? 'tag-grid-head-cntrl-dis mx-2' : 'tag-grid-head-cntrl mx-2'}onClick={handleCopySizing} /></label></StyledTooltip>
                  </div> */}

                  <div style={{ height: "65vh" }}>

                    <AgGridReact
                      statusBar={statusBar}
                      ref={childGridRef}
                      className='inner-popup-copy-tag'
                      groupHeaderHeight={25}
                      headerHeight={25}
                      rowData={childPopUpArray}
                      localeText={agGridTrans[localStorage.getItem("lang")]}
                      components={{ linPkgsRenderer: PkgSelRenderer, divSel: DivSel, tagStat: TagStatus }}
                      columnDefs={colDefinationsChild}
                      // defaultColDef={{ sortable: false }}
                      defaultColDef={gridDefinitionChild.defaultColDef}
                      rowHeight={26}
                      getRowId={ele => ele.data.tag_id}
                      onCellValueChanged={(rec) => onCellValueChanged(rec)}
                      onGridReady={onGridReadyChild}
                      rowSelection={"multiple"}
                      stopEditingWhenCellsLoseFocus={true}
                      enableRangeSelection={true}
                      suppressCopyRowsToClipboard={true}
                      excelStyles={excelStyles}
                      headerCheckboxSelection={true}
                      onSelectionChanged={onSelectionChangedCopySizing}
                    // getRowStyle={getRowStyleParent}
                    />
                  </div>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className="model-actions" style={{ "paddingRight": "24px" }}>
              <button className="cnbtn btn cancel-btn" variant="outlined" onClick={(e) => { copySizingClose(); }} style={{ "marginRight": "5px" }}>
                {t('Cancel')}
              </button>
              <button className="sbtn btn copy-btn" variant="contained" color="success" disabled={(selectedRowsDataCopy && (selectedRowsDataCopy.length > 0) ? false : true)} onClick={() => { setConfirmationPopup(true); }}>
                {t('Copy')}
              </button>
              {/* <button className="sbtn btn delink-btn" variant="contained" color="success" disabled={(showProgressBar || !removeIcon) || removeIcon === 'all'} onClick={() => { removeIcon && removeIcon !== null && errors === 0 && handleRemoveChildTag(); }}>
                Delink
              </button> */}

              {/* <Button className="sbtn btn btn-secondary right-space" variant="contained" color="success" disabled={copyConfDisableBtn} onClick={(e) => { handleCopyConfigValidate(); }}>
                Save
              </Button> */}
            </DialogActions>
          </Dialog>
        }

        {
          confirmationPopup &&
          <Dialog open={confirmationPopup} onClose={() => { setConfirmationPopup() }} className="copy-configuration-model-confirm muiForm-Modal" PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title">
            <DialogTitle className="model-title mb-0">{t('Confirm')}</DialogTitle>
            <DialogContent>
              <div className='confirm-div'><span className='confirm-text'>

                {selectedCopyTag.length > 20 ? t('You have selected more than 20 tags, only the first 20 tags will be copied. Would you like to proceed?') : t('Would you like to proceed?')}

              </span></div>
            </DialogContent>
            <DialogActions className='model-actions' style={{ "paddingLeft": "24px", "paddingRight": "24px" }}>
              <Button className="cnbtn btn cancel-btn" variant="outlined" onClick={(e) => { setConfirmationPopup(false); }} style={{ "marginRight": "5px" }}>
                {t('Cancel')}
              </Button>
              <Button className="sbtn btn copy-btn" variant="contained" color="success" disabled={false} onClick={() => { handleCopySizing(); }}>
                {t('Yes')}
              </Button>
            </DialogActions>
          </Dialog>
        }

        <Dialog open={confirmationPopup1} onClose={() => setConfirmationPopup1(false)} className="copy-configuration-model-confirm muiForm-Modal a" PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" PaperProps={{
          style: {
            width: '600px',
            maxWidth: '100%',
            height: 'auto'
          }
        }} >
          <DialogTitle className="model-title mb-0">{t('Note')}</DialogTitle>
          <DialogContent >
            <div className='confirm-div'><span className='confirm-text'>{t('Only Configured Tags, with Valid Configuration Status (Configuration Import Success) will be auto-selected to be displayed in the Configuration Detail Window.')} </span></div>
          </DialogContent>
          <DialogActions className='model-actions' style={{ "paddingLeft": "24px", "paddingRight": "24px" }}>
            {/* <Button onClick={() => setConfirmationPopup(false)} color="primary">
            Cancel
          </Button> */}
            <Button className="cnbtn btn cancel-btn" variant="outlined" onClick={(e) => { setConfirmationPopup1(false); }} style={{ "marginRight": "5px" }}>
              {t('Cancel')}
            </Button>
            {/* <Button onClick={handleConfirmationYes} color="primary">
            Yes
          </Button> */}
            <Button className="sbtn btn copy-btn" variant="contained" color="success" disabled={false} onClick={() => { handleConfirmationYes(); }}>
              {t('Proceed')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* // for launching ppa pricing---- */}
        <Dialog open={confirmationPopup2} onClose={() => setConfirmationPopup2(false)} className="copy-configuration-model-confirm muiForm-Modal a" PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" PaperProps={{
          style: {
            width: '600px',
            maxWidth: '100%',
            height: 'auto'
          }
        }} >
          <DialogTitle className="model-title mb-0">Note</DialogTitle>
          <DialogContent >
            <div className='confirm-div'><span className='confirm-text'>LAUNCHED PPA</span></div>
          </DialogContent>
          <DialogActions className='model-actions' style={{ "paddingLeft": "24px", "paddingRight": "24px" }}>
            {/* <Button onClick={() => setConfirmationPopup(false)} color="primary">
                Cancel
              </Button> */}
            { /* <Button className="cnbtn btn cancel-btn" variant="outlined" onClick={(e) => { setConfirmationPopup2(false); }} style ={{"marginRight":"5px"}}>
          Cancel
            </Button>*/}
            {/* <Button onClick={handleConfirmationYes} color="primary">
        //         Yes
        //       </Button> */}
            <Button className="sbtn btn copy-btn" variant="contained" color="success" disabled={false} onClick={(e) => { setConfirmationPopup2(false); }}>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        {/* //cloespopup// */}



        {/* //----for btn click on both import and launch---- */}

        <Dialog open={confirmationPopup3} onClose={() => setConfirmationPopup3(false)} className="copy-configuration-model-confirm muiForm-Modal a" PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" PaperProps={{
          style: {
            width: '600px',
            maxWidth: '100%',
            height: 'auto'
          }
        }} >
          <DialogTitle className="model-title mb-0">{t('Note')}</DialogTitle>
          <DialogContent >
            <div className='confirm-div'><span className='confirm-text'>{t('Data imported successfully. Would you like to launch PPA?')} </span></div>
          </DialogContent>
          <DialogActions className='model-actions' style={{ "paddingLeft": "24px", "paddingRight": "24px" }}>
            {/* <Button onClick={() => setConfirmationPopup3(false)} color="primary">
                     Cancel
                   </Button> */}
            <Button className="cnbtn btn cancel-btn" variant="outlined" onClick={(e) => { setConfirmationPopup3(false); }} style={{ "marginRight": "5px" }}>
              {t('Cancel')}
            </Button>
            {/* <Button onClick={handleConfirmationYes} color="primary">
                     Yes
                   </Button> */}
            <Button className="sbtn btn copy-btn" variant="contained" color="success" disabled={false} onClick={() => { handleLinkClick(); }}>
              {t('Proceed')}
            </Button>
          </DialogActions>
        </Dialog>

        {isLinkTagOpen &&
          <LinkTag
            selectedRowsData={selectedRowsData}
            isLinkTagOpen={isLinkTagOpen}
            setIsLinkTagOpen={setIsLinkTagOpen}
            colDefs={createDefs(lookupTables['Common'], false)}
          />}

        <RelatedTagModal
          isRelTagModalOpen={isRelTagModalOpen}
          setIsRelTagModalOpen={setIsRelTagModalOpen}
          relTagData={relTagData}
        />
      </div >


    </>
  )
}

export default PrjTagTable;